


// import React, { useState, useEffect, useRef } from 'react';
// import axios from 'axios';
// import { FaEdit, FaTrash } from 'react-icons/fa';
// import BankModal from './BankModal';
// import ReactPaginate from 'react-paginate';
// import { Link } from 'react-router-dom';
// import { useAuth } from '../../../context/AuthContext';
// import withPermission from '../../../utils/withPermission';
// import Swal from 'sweetalert2';
// import { FaFilter } from "react-icons/fa";

// const BankDetailList = () => {
//     const [banks, setBanks] = useState([]);
//     const [showModal, setShowModal] = useState(false);
//     const [isLoading, setIsLoading] = useState(false);
//     const [selectedBankId, setSelectedBankId] = useState(null);
//     const [selectedBankData, setSelectedBankData] = useState(null);
//     const [currentPage, setCurrentPage] = useState(0);
//     const [pageCount, setPageCount] = useState(0);
//     const [errors, setErrors] = useState('');
//     const [searchQuery, setSearchQuery] = useState('');
//     const debounceTimeoutRef = useRef(null);
//     const firstLoad = useRef(true);
//     const { roles, permissions } = useAuth();
//     const [allBanks, setAllBanks] = useState([]);
//     const [countries, setCountries] = useState([]);
//     const [typeFilter, setTypeFilter] = useState('');
//     const [filterDropdown, setFilterDropdown] = useState(null);
//     const fetchBanks = async (page = 1) => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;

//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');

//             const token = userInfo?.token;
//             let params = { page };
//             if (typeFilter) params.type = typeFilter;
//             if (searchQuery) params.search = searchQuery;
//             const response = await axios.get(`${backendUrl}/api/bank-accounts`, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Tenant-Origin': origin,

//                 },
//                 params,
//             });

//             const { data, current_page, last_page } = response.data.account;

//             setBanks(data);

//             setCurrentPage(current_page - 1);
//             setPageCount(last_page);
//         } catch (error) {
//             console.error('Error fetching banks:', error);
//         }
//     };
//     const [bankLedgers, setBankLedgers] = useState([]);
//     const [totalBalance, setTotalBalance] = useState(0);
//     const [payableBalance, setPayableBalance] = useState(0); // If needed from another API
//     const [actualBalance, setActualBalance] = useState(0);

//     const fetchBankLedgers = async () => {
//         try {
//             const Api = process.env.REACT_APP_WEBZASH_URL;
//             const apiKey = process.env.REACT_APP_API_KEY;

//             // Fetch bank ledger data
//             const responseLedger = await axios.get(`${Api}/api/reports/balancesheet`, {
//                 headers: { 'x-api-key': apiKey, 'Accept': 'application/json' },
//             });

//             const bankAsset = responseLedger.data.data.assets.find(
//                 (asset) => asset.name === 'Bank Accounts'
//             );

//             let total = 0;
//             if (bankAsset) {
//                 setBankLedgers(bankAsset.children || []);
//                 total = bankAsset.children.reduce((sum, bank) => sum + parseFloat(bank.amount), 0);
//                 setTotalBalance(total);
//             }

//             // Fetch payable balance from your backend expense API
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem("user-info"));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const responseExpense = await axios.get(`${backendUrl}/api/expense`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//             });

//             const totalExpense = responseExpense.data.total_expense_amount || 0;
//             setPayableBalance(totalExpense);

//             // Actual balance = total bank - payable
//             setActualBalance(total - totalExpense);

//         } catch (error) {
//             console.error('Error fetching bank ledgers or expenses:', error);
//         }
//     };


//     useEffect(() => {
//         fetchBankLedgers();
//     }, []);


//     const fetchCountries = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');

//             const token = userInfo?.token;

//             const response = await axios.get(`${backendUrl}/api/countries`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,

//                 },
//                 skipLoader: true,
//             });

//             let countryList = response.data.Data;

//             // Ensure country with ID 231 (AED) appears first
//             countryList = countryList.sort((a, b) => (a.id === 231 ? -1 : b.id === 231 ? 1 : 0));

//             setCountries(countryList);
//         } catch (error) {
//             console.error('Error fetching countries:', error);
//         }
//     };


//     useEffect(() => {
//         if (debounceTimeoutRef.current) {
//             clearTimeout(debounceTimeoutRef.current);
//         }

//         debounceTimeoutRef.current = setTimeout(() => {
//             fetchBanks(1, searchQuery);
//         }, searchQuery ? 1500 : 0);

//         return () => {
//             if (debounceTimeoutRef.current) {
//                 clearTimeout(debounceTimeoutRef.current);
//             }
//         };
//     }, [searchQuery, typeFilter]);



//     const handleSearchChange = (e) => {
//         setSearchQuery(e.target.value);

//     };
//     //     const canEdit = permissions.includes('bank-edit');
//     //   const canDelete = permissions.includes('bank-delete');
//     const WithDeletePermission = withPermission(({ children }) => children, ['bankaccount-delete']);
//     const WithEditPermission = withPermission(({ children }) => children, ['bankaccount-edit']);
//     const WithCreatePermission = withPermission(({ children }) => children, ['bankaccount-create']);



//     const addBank = async (newBank) => {

//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;

//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.post(`${backendUrl}/api/bank-accounts`, newBank, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//             });
//             const createdBank = response.data?.account;
//             if (createdBank) {
//                 setBanks((prevBanks) => [...prevBanks, createdBank]);
//             } else {
//                 console.error('Creation failed, no data returned.');
//             }

//             handleCloseModal(); // Close modal after adding
//         } catch (error) {
//             if (error.response?.data?.errors) {
//                 return error.response.data.errors; // Return validation errors
//             } else {
//                 console.error('Error adding bank:', error);
//             }
//         }
//     };


//     const editBank = async (bankId, updatedData) => {

//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;

//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.put(`${backendUrl}/api/bank-accounts/${bankId}`, updatedData, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//             });
//             const updatedBank = response.data?.account;

//             if (updatedBank) {
//                 setBanks((prevBanks) =>
//                     prevBanks.map((bank) =>
//                         bank.id === updatedBank.id ? updatedBank : bank
//                     )
//                 );
//             } else {
//                 console.error('Update failed, no data returned.');
//             }

//             handleCloseModal();
//         } catch (error) {
//             if (error.response?.data?.errors) {
//                 return error.response.data.errors; // Return validation errors
//             } else {
//                 console.error('Error updating bank:', error);
//             }
//         }
//     };

//     const deleteBank = async (id) => {
//         Swal.fire({
//             title: "Are you sure?",
//             text: "You won't be able to revert this!",
//             icon: "warning",
//             showCancelButton: true,
//             confirmButtonColor: "#d33",
//             cancelButtonColor: "#3085d6",
//             confirmButtonText: "Yes, delete it!"
//         }).then(async (result) => {
//             if (result.isConfirmed) {
//                 try {
//                     const backendUrl = process.env.REACT_APP_BACKEND_URL;

//                     const userInfo = JSON.parse(localStorage.getItem('user-info'));
//                     const origin = localStorage.getItem('user-origin');
//                     const token = userInfo?.token;

//                     await axios.delete(`${backendUrl}/api/bank-accounts/${id}`, {
//                         headers: {
//                             'Authorization': `Bearer ${token}`,
//                             'Tenant-Origin': origin,
//                         },
//                     });

//                     setBanks(banks.filter(bank => bank.id !== id));
//                     Swal.fire(
//                         "Deleted!",
//                         "The bank has been deleted.",
//                         "success"
//                     );
//                 } catch (error) {
//                     console.error('Error deleting bank:', error);
//                     Swal.fire(
//                         "Error!",
//                         "Failed to delete bank. Please try again.",
//                         "error"
//                     );
//                 }
//             }
//         });
//     };

//     const handleShowModal = (bankId = null) => {

//         if (bankId) {
//             const bankToEdit = banks.find(bank => bank.id === bankId);
//             if (bankToEdit) {
//                 setSelectedBankData(bankToEdit);
//             }
//         } else {
//             setSelectedBankData(null);
//         }
//         setSelectedBankId(bankId);
//         setShowModal(true);
//     };

//     const handleCloseModal = () => {
//         setShowModal(false);
//         setSelectedBankId(null);
//         setSelectedBankData(null);
//         setErrors({});
//     };

//     const handlePageClick = (data) => {
//         const selectedPage = data.selected + 1;
//         fetchBanks(selectedPage);
//     };
//     const handleFilterChange = (filterType, value) => {
//         if (filterType === 'type') setTypeFilter(value);

//         setFilterDropdown(null); // Close dropdown after selection
//     };
//     const handleImport = async (event) => {
//         const file = event.target.files[0];
//         if (!file) return;

//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const formData = new FormData();
//             formData.append('file', file);

//             const response = await axios.post(
//                 `${backendUrl}/api/bank-accounts/import`,
//                 formData,
//                 {
//                     headers: {
//                         Authorization: `Bearer ${token}`,
//                         'Content-Type': 'multipart/form-data',
//                         'Tenant-Origin': origin,
//                     },
//                 }
//             );

//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'success',
//                 title: response.data.message || ` Imported successfully!`,
//                 timer: 3000,
//                 timerProgressBar: false,
//                 showConfirmButton: false,
//                 didOpen: () => {
//                     const container = Swal.getContainer();
//                     container.style.top = '50px';
//                 },
//             });

//             // Refresh the list after import
//             setTimeout(() => window.location.reload(), 1000);

//             // Clear the file input
//             event.target.value = '';

//         } catch (error) {
//             console.error('Import error:', error);
//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'error',
//                 title: error.response?.data?.errors || error.response?.errors || `Failed to import instance information`,
//                 timer: 3000,
//                 timerProgressBar: false,
//                 showConfirmButton: false,
//                 didOpen: () => {
//                     const container = Swal.getContainer();
//                     container.style.top = '50px';
//                 },
//             });
//             event.target.value = "";

//         } finally {
//         }
//     };

//     // Export Functions
//     const handleExport = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.get(
//                 `${backendUrl}/api/bank-accounts/export`,
//                 {
//                     headers: {
//                         Authorization: `Bearer ${token}`,
//                         'Tenant-Origin': origin,
//                     },
//                     responseType: 'blob', // Important for file download
//                 }
//             );

//             // Create blob link and download
//             const blob = new Blob([response.data]);
//             const url = window.URL.createObjectURL(blob);
//             const link = document.createElement('a');
//             link.href = url;

//             // Get filename from response headers or use default
//             const contentDisposition = response.headers['content-disposition'];
//             let filename = `BankAccounts_${new Date().toISOString().split('T')[0]}.xlsx`;

//             if (contentDisposition) {
//                 const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
//                 if (filenameMatch.length === 2) {
//                     filename = filenameMatch[1];
//                 }
//             }

//             link.setAttribute('download', filename);
//             document.body.appendChild(link);
//             link.click();
//             link.remove();
//             window.URL.revokeObjectURL(url);

//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'success',
//                 title: `Exported successfully!`,
//                 timer: 2000,
//                 timerProgressBar: false,
//                 showConfirmButton: false,
//                 didOpen: () => {
//                     const container = Swal.getContainer();
//                     container.style.top = '50px';
//                 },
//             });

//         } catch (error) {
//             console.error('Export error:', error);
//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'error',
//                 title: `Failed to export`,
//                 timer: 3000,
//                 timerProgressBar: false,
//                 showConfirmButton: false,
//                 didOpen: () => {
//                     const container = Swal.getContainer();
//                     container.style.top = '50px';
//                 },
//             });
//         } finally {
//         }
//     };
//     return (
//         <div className="main-content">
//             <div className="page-content">
//                 <div className="container-fluid">
//                     {/* Page Title */}

//                     <div className="row">
//                         <div className="col-12">
//                             <div className="page-title-box d-sm-flex align-items-center justify-content-between">
//                                 <h4 className="mb-sm-0 font-size-18">Bank Details</h4>

//                             </div>
//                         </div>
//                     </div>

//                     {/* Bank Table */}
//                     <div className="row">
//                         <div className="col-12">
//                             <div className="card">
//                                 <div className="card-body">
//                                     {/* <div className="d-flex justify-content-end mb-3"> */}
//                                     <div className="d-flex justify-content-between mb-3">
//                                         <div className="d-flex">
//                                             <div className="search-box me-2 mb-2 d-inline-block">
//                                                 <div className="position-relative">
//                                                     <input
//                                                         type="text"
//                                                         className="form-control font-size-12"
//                                                         placeholder="Search..."
//                                                         value={searchQuery}
//                                                         onChange={handleSearchChange}
//                                                     />
//                                                     <i className="bx bx-search-alt search-icon" />
//                                                 </div>
//                                             </div>



//                                         </div>
//                                         <div className="d-flex align-items-center gap-2">
//                                             {/* Export Button */}
//                                             {/* <button
//                                                 type="button"
//                                                 className="btn btn-light border"
//                                                 onClick={handleExport}
//                                                 data-bs-toggle="tooltip"
//                                                 data-bs-placement="top"
//                                                 title="Export"
//                                             >
//                                                 <i className="mdi mdi-file-excel text-success"></i>
//                                             </button>

//                                             <input
//                                                 type="file"
//                                                 accept=".xlsx, .xls"
//                                                 id="importLeadsFile"
//                                                 onChange={handleImport}
//                                                 style={{ display: "none" }}
//                                             />
//                                             <label
//                                                 htmlFor="importLeadsFile"
//                                                 className="btn btn-light border mb-0"
//                                                 data-bs-toggle="tooltip"
//                                                 data-bs-placement="top"
//                                                 title="Import"
//                                             >
//                                                 <i className="mdi mdi-upload text-primary"></i>
//                                             </label> */}
//                                             <WithCreatePermission>
//                                                 <button
//                                                     type="button"
//                                                     className="btn rounded-circle border d-flex align-items-center justify-content-center round-create-button"

//                                                     onClick={() => handleShowModal()} // Updated line
//                                                     data-bs-toggle="tooltip"
//                                                     data-bs-placement="top"
//                                                     title="Add Bank"
//                                                 >
//                                                     <i className="mdi mdi-plus" ></i>
//                                                 </button>
//                                             </WithCreatePermission>
//                                         </div>
//                                     </div>
//                                     {/* Table */}
//                                     <div>
//                                         <table className="table align-middle table-nowrap table-check table-list">

//                                             <thead className="table-light">
//                                                 <tr>
//                                                     <th style={{ width: '20px' }} className="align-middle">
//                                                         <div className="form-check font-size-16">
//                                                             <input className="form-check-input" type="checkbox" id="checkAll" />
//                                                             <label className="form-check-label" htmlFor="checkAll"></label>
//                                                         </div>
//                                                     </th>
//                                                     <th className="align-middle">#</th>
//                                                     <th>Bank Account</th>
//                                                     <th className="text-end">Balance (AED)</th>
//                                                 </tr>
//                                             </thead>

//                                             {/* <tbody>
//                                                 {bankLedgers.map((bank, index) => (
//                                                     <tr key={index}>
//                                                          <td>
//                                                                 <div className="form-check font-size-16">
//                                                                     <input
//                                                                         className="form-check-input"
//                                                                         type="checkbox"
//                                                                         id={`bankCheck${index}`}
//                                                                     />
//                                                                     <label
//                                                                         className="form-check-label"
//                                                                         htmlFor={`bankCheck${index}`}
//                                                                     ></label>
//                                                                 </div>
//                                                             </td>
//                                                         <td>{index + 1}</td>
//                                                         <td>{bank.name}</td>
//                                                         <td className="text-end">
//                                                             {parseFloat(bank.amount).toLocaleString("en-US", { minimumFractionDigits: 2 })}
//                                                         </td>
//                                                     </tr>
//                                                 ))}

//                                                 <tr className="fw-bold">
//                                                     <td colSpan={3}>TOTAL BALANCE</td>
//                                                     <td className="text-end">{totalBalance.toFixed(2)}</td>
//                                                 </tr>

//                                                 <tr className="fw-bold text-danger">
//                                                     <td colSpan={3}>PAYABLE BALANCE</td>
//                                                     <td className="text-end">{payableBalance.toFixed(2)}</td>
//                                                 </tr>

//                                                 <tr className="fw-bold text-success">
//                                                     <td colSpan={3}>ACTUAL AVAILABLE BALANCE</td>
//                                                     <td className="text-end">{actualBalance.toFixed(2)}</td>
//                                                 </tr>
//                                             </tbody> */}
//                                             <tbody>
//                                                 {bankLedgers.length > 0 ? (
//                                                     bankLedgers.map((bank, index) => (
//                                                         <tr key={index} className="bank-item">
//                                                             <td>
//                                                                 <div className="form-check font-size-16">
//                                                                     <input
//                                                                         className="form-check-input"
//                                                                         type="checkbox"
//                                                                         id={`bankCheck${index}`}
//                                                                     />
//                                                                 </div>
//                                                             </td>
//                                                             <td>
//                                                                 <div className="serial-number">{index + 1}</div>
//                                                             </td>
//                                                             <td>
//                                                                 <div className="bank-info">
//                                                                     <div className="bank-name">{bank.name}</div>

//                                                                 </div>
//                                                             </td>
//                                                             <td className="text-end">
//                                                                 <div className="balance-container">
//                                                                     <div className="balance-figure">
//                                                                         {parseFloat(bank.amount || 0).toLocaleString("en-US", {
//                                                                             minimumFractionDigits: 2,
//                                                                             maximumFractionDigits: 2
//                                                                         })}
//                                                                     </div>

//                                                                 </div>
//                                                             </td>
//                                                         </tr>
//                                                     ))
//                                                 ) : (
//                                                     <tr>
//                                                         <td colSpan="4" className="text-center py-5">
//                                                             <div className="no-data">
//                                                                 <i className="mdi mdi-database-remove-outline display-4 text-light"></i>
//                                                                 <h6 className="mt-3 text-muted">No bank accounts available</h6>
//                                                             </div>
//                                                         </td>
//                                                     </tr>
//                                                 )}

//                                                 {/* Summary Section */}


//                                                 <tr className="summary-row total">
//                                                     <td colSpan={3}>
//                                                         <strong>Total Balance</strong>
//                                                     </td>
//                                                     <td className="text-end">
//                                                         <strong> {totalBalance.toLocaleString("en-US", {
//                                                             minimumFractionDigits: 2,
//                                                             maximumFractionDigits: 2
//                                                         })}</strong>
//                                                     </td>
//                                                 </tr>

//                                                 {payableBalance > 0 && (
//                                                     <tr className="summary-row payable">
//                                                         <td colSpan={3}>
//                                                             <span className="text-danger">Payable </span>
//                                                         </td>
//                                                         <td className="text-end text-danger">
//                                                              {payableBalance.toLocaleString("en-US", {
//                                                                 minimumFractionDigits: 2,
//                                                                 maximumFractionDigits: 2
//                                                             })}
//                                                         </td>
//                                                     </tr>
//                                                 )}

//                                                 <tr className="summary-row available">
//                                                     <td colSpan={3}>
//                                                         <span className="text-success">Available Balance</span>
//                                                     </td>
//                                                     <td className="text-end text-success">
//                                                         <strong> {actualBalance.toLocaleString("en-US", {
//                                                             minimumFractionDigits: 2,
//                                                             maximumFractionDigits: 2
//                                                         })}</strong>
//                                                     </td>
//                                                 </tr>
//                                             </tbody>

//                                         </table>
//                                         {/* <div className="d-flex justify-content-between align-items-center mt-3">
//                                             <span style={{fontSize:'12px',color:'#6e6e6e'}}>Showing 1 to 10 of {banks.length} entries</span> */}
//                                         <div className="d-flex justify-content-end pagination-sm">
//                                             <ReactPaginate
//                                                 previousLabel={'<'}
//                                                 nextLabel={'>'}
//                                                 breakLabel={'...'}
//                                                 pageCount={pageCount}
//                                                 marginPagesDisplayed={2}
//                                                 pageRangeDisplayed={3}
//                                                 onPageChange={handlePageClick}
//                                                 containerClassName={'pagination pagination-rounded justify-content-end mb-2'}
//                                                 pageClassName={'page-item'}
//                                                 pageLinkClassName={'page-link'}
//                                                 previousClassName={'page-item previous'}
//                                                 previousLinkClassName={'page-link'}
//                                                 nextClassName={'page-item next'}
//                                                 nextLinkClassName={'page-link'}
//                                                 breakClassName={'page-item'}
//                                                 breakLinkClassName={'page-link'}
//                                                 activeClassName={'active'}
//                                             />
//                                         </div>
//                                         {/* </div> */}
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     <BankModal
//                         key={selectedBankId || 'new'}
//                         showModal={showModal}
//                         handleClose={handleCloseModal}
//                         bankId={selectedBankId}
//                         bankData={selectedBankData}
//                         addBank={addBank}
//                         editBank={editBank}
//                         banks={banks}
//                         errors={errors}
//                         setErrors={setErrors}
//                         countries={countries}
//                         fetchCountries={fetchCountries}

//                     />
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default BankDetailList;

// import React, { useState, useEffect, useRef } from 'react';
// import axios from 'axios';
// import { FaEdit, FaTrash } from 'react-icons/fa';
// import BankModal from './BankModal';
// import ReactPaginate from 'react-paginate';
// import { Link } from 'react-router-dom';
// import { useAuth } from '../../../context/AuthContext';
// import withPermission from '../../../utils/withPermission';
// import Swal from 'sweetalert2';
// import { FaFilter } from "react-icons/fa";

// const BankDetailList = () => {
//     const [banks, setBanks] = useState([]);
//     const [showModal, setShowModal] = useState(false);
//     const [isLoading, setIsLoading] = useState(false);
//     const [selectedBankId, setSelectedBankId] = useState(null);
//     const [selectedBankData, setSelectedBankData] = useState(null);
//     const [currentPage, setCurrentPage] = useState(0);
//     const [pageCount, setPageCount] = useState(0);
//     const [errors, setErrors] = useState('');
//     const [searchQuery, setSearchQuery] = useState('');
//     const debounceTimeoutRef = useRef(null);
//     const firstLoad = useRef(true);
//     const { roles, permissions } = useAuth();
//     const [allBanks, setAllBanks] = useState([]);
//     const [countries, setCountries] = useState([]);
//     const [typeFilter, setTypeFilter] = useState('');
//     const [filterDropdown, setFilterDropdown] = useState(null);

//     // Exchange rate state (you might want to fetch this from an API)
//     const [exchangeRate, setExchangeRate] = useState(3.692); // Default AED to USD rate

//     const fetchBanks = async (page = 1) => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;

//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');

//             const token = userInfo?.token;
//             let params = { page };
//             if (typeFilter) params.type = typeFilter;
//             if (searchQuery) params.search = searchQuery;
//             const response = await axios.get(`${backendUrl}/api/bank-accounts`, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Tenant-Origin': origin,

//                 },
//                 params,
//             });

//             const { data, current_page, last_page } = response.data.account;

//             setBanks(data);

//             setCurrentPage(current_page - 1);
//             setPageCount(last_page);
//         } catch (error) {
//             console.error('Error fetching banks:', error);
//         }
//     };
//     const [bankLedgers, setBankLedgers] = useState([]);
//     const [totalBalance, setTotalBalance] = useState(0);
//     const [payableBalance, setPayableBalance] = useState(0);
//     const [actualBalance, setActualBalance] = useState(0);

//     // Calculate USD balances
//     const totalBalanceUSD = totalBalance / exchangeRate;
//     const payableBalanceUSD = payableBalance / exchangeRate;
//     const actualBalanceUSD = actualBalance / exchangeRate;

//     const fetchBankLedgers = async () => {
//         try {
//             const Api = process.env.REACT_APP_WEBZASH_URL;
//             const apiKey = process.env.REACT_APP_API_KEY;

//             // Fetch bank ledger data
//             const responseLedger = await axios.get(`${Api}/api/reports/balancesheet`, {
//                 headers: { 'x-api-key': apiKey, 'Accept': 'application/json' },
//             });

//             const bankAsset = responseLedger.data.data.assets.find(
//                 (asset) => asset.name === 'Bank Accounts'
//             );

//             let total = 0;
//             if (bankAsset) {
//                 setBankLedgers(bankAsset.children || []);
//                 total = bankAsset.children.reduce((sum, bank) => sum + parseFloat(bank.amount), 0);
//                 setTotalBalance(total);
//             }

//             // Fetch payable balance from your backend expense API
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem("user-info"));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const responseExpense = await axios.get(`${backendUrl}/api/expense`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//             });

//             const totalExpense = responseExpense.data.total_expense_amount || 0;
//             setPayableBalance(totalExpense);

//             // Actual balance = total bank - payable
//             setActualBalance(total - totalExpense);

//         } catch (error) {
//             console.error('Error fetching bank ledgers or expenses:', error);
//         }
//     };

//     // Fetch exchange rate (you can replace this with your actual exchange rate API)
//     const fetchExchangeRate = async () => {
//         try {
//             // Example: You can use an external API for real exchange rates
//             // const response = await axios.get('https://api.exchangerate-api.com/v4/latest/AED');
//             // setExchangeRate(response.data.rates.USD);

//             // For now, using a fixed rate - replace with actual API call
//             setExchangeRate(3.692);
//         } catch (error) {
//             console.error('Error fetching exchange rate:', error);
//             // Fallback to default rate
//             setExchangeRate(3.692);
//         }
//     };

//     useEffect(() => {
//         fetchBankLedgers();
//         fetchExchangeRate();
//     }, []);

//     const fetchCountries = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');

//             const token = userInfo?.token;

//             const response = await axios.get(`${backendUrl}/api/countries`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,

//                 },
//                 skipLoader: true,
//             });

//             let countryList = response.data.Data;

//             // Ensure country with ID 231 (AED) appears first
//             countryList = countryList.sort((a, b) => (a.id === 231 ? -1 : b.id === 231 ? 1 : 0));

//             setCountries(countryList);
//         } catch (error) {
//             console.error('Error fetching countries:', error);
//         }
//     };

//     useEffect(() => {
//         if (debounceTimeoutRef.current) {
//             clearTimeout(debounceTimeoutRef.current);
//         }

//         debounceTimeoutRef.current = setTimeout(() => {
//             fetchBanks(1, searchQuery);
//         }, searchQuery ? 1500 : 0);

//         return () => {
//             if (debounceTimeoutRef.current) {
//                 clearTimeout(debounceTimeoutRef.current);
//             }
//         };
//     }, [searchQuery, typeFilter]);

//     const handleSearchChange = (e) => {
//         setSearchQuery(e.target.value);
//     };

//     const WithDeletePermission = withPermission(({ children }) => children, ['bankaccount-delete']);
//     const WithEditPermission = withPermission(({ children }) => children, ['bankaccount-edit']);
//     const WithCreatePermission = withPermission(({ children }) => children, ['bankaccount-create']);

//     const addBank = async (newBank) => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;

//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.post(`${backendUrl}/api/bank-accounts`, newBank, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//             });
//             const createdBank = response.data?.account;
//             if (createdBank) {
//                 setBanks((prevBanks) => [...prevBanks, createdBank]);
//             } else {
//                 console.error('Creation failed, no data returned.');
//             }

//             handleCloseModal();
//         } catch (error) {
//             if (error.response?.data?.errors) {
//                 return error.response.data.errors;
//             } else {
//                 console.error('Error adding bank:', error);
//             }
//         }
//     };

//     const editBank = async (bankId, updatedData) => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;

//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.put(`${backendUrl}/api/bank-accounts/${bankId}`, updatedData, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//             });
//             const updatedBank = response.data?.account;

//             if (updatedBank) {
//                 setBanks((prevBanks) =>
//                     prevBanks.map((bank) =>
//                         bank.id === updatedBank.id ? updatedBank : bank
//                     )
//                 );
//             } else {
//                 console.error('Update failed, no data returned.');
//             }

//             handleCloseModal();
//         } catch (error) {
//             if (error.response?.data?.errors) {
//                 return error.response.data.errors;
//             } else {
//                 console.error('Error updating bank:', error);
//             }
//         }
//     };

//     const deleteBank = async (id) => {
//         Swal.fire({
//             title: "Are you sure?",
//             text: "You won't be able to revert this!",
//             icon: "warning",
//             showCancelButton: true,
//             confirmButtonColor: "#d33",
//             cancelButtonColor: "#3085d6",
//             confirmButtonText: "Yes, delete it!"
//         }).then(async (result) => {
//             if (result.isConfirmed) {
//                 try {
//                     const backendUrl = process.env.REACT_APP_BACKEND_URL;

//                     const userInfo = JSON.parse(localStorage.getItem('user-info'));
//                     const origin = localStorage.getItem('user-origin');
//                     const token = userInfo?.token;

//                     await axios.delete(`${backendUrl}/api/bank-accounts/${id}`, {
//                         headers: {
//                             'Authorization': `Bearer ${token}`,
//                             'Tenant-Origin': origin,
//                         },
//                     });

//                     setBanks(banks.filter(bank => bank.id !== id));
//                     Swal.fire(
//                         "Deleted!",
//                         "The bank has been deleted.",
//                         "success"
//                     );
//                 } catch (error) {
//                     console.error('Error deleting bank:', error);
//                     Swal.fire(
//                         "Error!",
//                         "Failed to delete bank. Please try again.",
//                         "error"
//                     );
//                 }
//             }
//         });
//     };

//     const handleShowModal = (bankId = null) => {
//         if (bankId) {
//             const bankToEdit = banks.find(bank => bank.id === bankId);
//             if (bankToEdit) {
//                 setSelectedBankData(bankToEdit);
//             }
//         } else {
//             setSelectedBankData(null);
//         }
//         setSelectedBankId(bankId);
//         setShowModal(true);
//     };

//     const handleCloseModal = () => {
//         setShowModal(false);
//         setSelectedBankId(null);
//         setSelectedBankData(null);
//         setErrors({});
//     };

//     const handlePageClick = (data) => {
//         const selectedPage = data.selected + 1;
//         fetchBanks(selectedPage);
//     };

//     const handleFilterChange = (filterType, value) => {
//         if (filterType === 'type') setTypeFilter(value);
//         setFilterDropdown(null);
//     };

//     const handleImport = async (event) => {
//         const file = event.target.files[0];
//         if (!file) return;

//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const formData = new FormData();
//             formData.append('file', file);

//             const response = await axios.post(
//                 `${backendUrl}/api/bank-accounts/import`,
//                 formData,
//                 {
//                     headers: {
//                         Authorization: `Bearer ${token}`,
//                         'Content-Type': 'multipart/form-data',
//                         'Tenant-Origin': origin,
//                     },
//                 }
//             );

//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'success',
//                 title: response.data.message || ` Imported successfully!`,
//                 timer: 3000,
//                 timerProgressBar: false,
//                 showConfirmButton: false,
//                 didOpen: () => {
//                     const container = Swal.getContainer();
//                     container.style.top = '50px';
//                 },
//             });

//             setTimeout(() => window.location.reload(), 1000);
//             event.target.value = '';

//         } catch (error) {
//             console.error('Import error:', error);
//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'error',
//                 title: error.response?.data?.errors || error.response?.errors || `Failed to import instance information`,
//                 timer: 3000,
//                 timerProgressBar: false,
//                 showConfirmButton: false,
//                 didOpen: () => {
//                     const container = Swal.getContainer();
//                     container.style.top = '50px';
//                 },
//             });
//             event.target.value = "";
//         } finally {
//         }
//     };

//     const handleExport = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.get(
//                 `${backendUrl}/api/bank-accounts/export`,
//                 {
//                     headers: {
//                         Authorization: `Bearer ${token}`,
//                         'Tenant-Origin': origin,
//                     },
//                     responseType: 'blob',
//                 }
//             );

//             const blob = new Blob([response.data]);
//             const url = window.URL.createObjectURL(blob);
//             const link = document.createElement('a');
//             link.href = url;

//             const contentDisposition = response.headers['content-disposition'];
//             let filename = `BankAccounts_${new Date().toISOString().split('T')[0]}.xlsx`;

//             if (contentDisposition) {
//                 const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
//                 if (filenameMatch.length === 2) {
//                     filename = filenameMatch[1];
//                 }
//             }

//             link.setAttribute('download', filename);
//             document.body.appendChild(link);
//             link.click();
//             link.remove();
//             window.URL.revokeObjectURL(url);

//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'success',
//                 title: `Exported successfully!`,
//                 timer: 2000,
//                 timerProgressBar: false,
//                 showConfirmButton: false,
//                 didOpen: () => {
//                     const container = Swal.getContainer();
//                     container.style.top = '50px';
//                 },
//             });

//         } catch (error) {
//             console.error('Export error:', error);
//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'error',
//                 title: `Failed to export`,
//                 timer: 3000,
//                 timerProgressBar: false,
//                 showConfirmButton: false,
//                 didOpen: () => {
//                     const container = Swal.getContainer();
//                     container.style.top = '50px';
//                 },
//             });
//         } finally {
//         }
//     };

//     // Format currency function
//     const formatCurrency = (amount, currency = 'AED') => {
//         return parseFloat(amount || 0).toLocaleString("en-US", {
//             minimumFractionDigits: 2,
//             maximumFractionDigits: 2
//         });
//     };

//     return (
//         <div className="main-content">
//             <div className="page-content">
//                 <div className="container-fluid">
//                     {/* Page Title */}
//                     <div className="row">
//                         <div className="col-12">
//                             <div className="page-title-box d-sm-flex align-items-center justify-content-between">
//                                 <h4 className="mb-sm-0 font-size-18">Bank Details</h4>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Exchange Rate Display */}


//                     {/* Bank Table */}
//                     <div className="row">
//                         <div className="col-12">
//                             <div className="card">
//                                 <div className="card-body">
//                                     <div className="d-flex justify-content-between mb-3">
//                                         <div className="d-flex">
//                                             <div className="search-box me-2 mb-2 d-inline-block">
//                                                 <div className="position-relative">
//                                                     <input
//                                                         type="text"
//                                                         className="form-control font-size-12"
//                                                         placeholder="Search..."
//                                                         value={searchQuery}
//                                                         onChange={handleSearchChange}
//                                                     />
//                                                     <i className="bx bx-search-alt search-icon" />
//                                                 </div>
//                                             </div>
//                                         </div>
//                                         <div className="d-flex align-items-center gap-2">
//                                             {/* <WithCreatePermission>
//                                                 <button
//                                                     type="button"
//                                                     className="btn rounded-circle border d-flex align-items-center justify-content-center round-create-button"
//                                                     onClick={() => handleShowModal()}
//                                                     data-bs-toggle="tooltip"
//                                                     data-bs-placement="top"
//                                                     title="Add Bank"
//                                                 >
//                                                     <i className="mdi mdi-plus" ></i>
//                                                 </button>
//                                             </WithCreatePermission> */}
//                                         </div>
//                                     </div>

//                                     {/* Table */}
//                                     <div>
//                                         <table className="table align-middle table-nowrap table-check table-list">
//                                             <thead className="table-light">
//                                                 <tr>
//                                                     <th style={{ width: '20px' }} className="align-middle">
//                                                         <div className="form-check font-size-16">
//                                                             <input className="form-check-input" type="checkbox" id="checkAll" />
//                                                             <label className="form-check-label" htmlFor="checkAll"></label>
//                                                         </div>
//                                                     </th>
//                                                     <th className="align-middle">#</th>
//                                                     <th>Bank Account</th>
//                                                     <th className="text-end">Balance (AED)</th>
//                                                     <th className="text-end">Balance (USD)</th>
//                                                 </tr>
//                                             </thead>

//                                             <tbody>
//                                                 {bankLedgers.length > 0 ? (
//                                                     bankLedgers.map((bank, index) => {
//                                                         const balanceAED = parseFloat(bank.amount || 0);
//                                                         const balanceUSD = balanceAED / exchangeRate;

//                                                         return (
//                                                             <tr key={index} className="bank-item">
//                                                                 <td>
//                                                                     <div className="form-check font-size-16">
//                                                                         <input
//                                                                             className="form-check-input"
//                                                                             type="checkbox"
//                                                                             id={`bankCheck${index}`}
//                                                                         />
//                                                                     </div>
//                                                                 </td>
//                                                                 <td>
//                                                                     <div className="serial-number">{index + 1}</div>
//                                                                 </td>
//                                                                 <td>
//                                                                     <div className="bank-info">
//                                                                         <div className="bank-name">{bank.name}</div>
//                                                                     </div>
//                                                                 </td>
//                                                                 <td className="text-end">
//                                                                     <div className="balance-container">
//                                                                         <div className="balance-figure">
//                                                                             {formatCurrency(balanceAED)} AED
//                                                                         </div>
//                                                                     </div>
//                                                                 </td>
//                                                                 <td className="text-end">
//                                                                     <div className="balance-container">
//                                                                         <div className="balance-figure">
//                                                                             {formatCurrency(balanceUSD)} USD
//                                                                         </div>
//                                                                     </div>
//                                                                 </td>
//                                                             </tr>
//                                                         );
//                                                     })
//                                                 ) : (
//                                                     <tr>
//                                                         <td colSpan="5" className="text-center py-5">
//                                                             <div className="no-data">
//                                                                 <i className="mdi mdi-database-remove-outline display-4 text-light"></i>
//                                                                 <h6 className="mt-3 text-muted">No bank accounts available</h6>
//                                                             </div>
//                                                         </td>
//                                                     </tr>
//                                                 )}

//                                                 {/* Summary Section */}
//                                                 <tr className="summary-row total">
//                                                     <td colSpan={3}>
//                                                         <strong>Total Balance</strong>
//                                                     </td>
//                                                     <td className="text-end">
//                                                         <strong>{formatCurrency(totalBalance)} AED</strong>
//                                                     </td>
//                                                     <td className="text-end">
//                                                         <strong>{formatCurrency(totalBalanceUSD)} USD</strong>
//                                                     </td>
//                                                 </tr>

//                                                 {payableBalance > 0 && (
//                                                     <tr className="summary-row payable">
//                                                         <td colSpan={3}>
//                                                             <span className="text-danger">Payable</span>
//                                                         </td>
//                                                         <td className="text-end text-danger">
//                                                             {formatCurrency(payableBalance)} AED
//                                                         </td>
//                                                         <td className="text-end text-danger">
//                                                             {formatCurrency(payableBalanceUSD)} USD
//                                                         </td>
//                                                     </tr>
//                                                 )}

//                                                 <tr className="summary-row available">
//                                                     <td colSpan={3}>
//                                                         <span className="text-success">Available Balance</span>
//                                                     </td>
//                                                     <td className="text-end text-success">
//                                                         <strong>{formatCurrency(actualBalance)} AED</strong>
//                                                     </td>
//                                                     <td className="text-end text-success">
//                                                         <strong>{formatCurrency(actualBalanceUSD)} USD</strong>
//                                                     </td>
//                                                 </tr>
//                                             </tbody>
//                                         </table>

//                                         <div className="d-flex justify-content-end pagination-sm">
//                                             <ReactPaginate
//                                                 previousLabel={'<'}
//                                                 nextLabel={'>'}
//                                                 breakLabel={'...'}
//                                                 pageCount={pageCount}
//                                                 marginPagesDisplayed={2}
//                                                 pageRangeDisplayed={3}
//                                                 onPageChange={handlePageClick}
//                                                 containerClassName={'pagination pagination-rounded justify-content-end mb-2'}
//                                                 pageClassName={'page-item'}
//                                                 pageLinkClassName={'page-link'}
//                                                 previousClassName={'page-item previous'}
//                                                 previousLinkClassName={'page-link'}
//                                                 nextClassName={'page-item next'}
//                                                 nextLinkClassName={'page-link'}
//                                                 breakClassName={'page-item'}
//                                                 breakLinkClassName={'page-link'}
//                                                 activeClassName={'active'}
//                                             />
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     <BankModal
//                         key={selectedBankId || 'new'}
//                         showModal={showModal}
//                         handleClose={handleCloseModal}
//                         bankId={selectedBankId}
//                         bankData={selectedBankData}
//                         addBank={addBank}
//                         editBank={editBank}
//                         banks={banks}
//                         errors={errors}
//                         setErrors={setErrors}
//                         countries={countries}
//                         fetchCountries={fetchCountries}
//                     />
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default BankDetailList;





import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { FaEdit, FaTrash } from 'react-icons/fa';
import BankModal from './BankModal';
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import withPermission from '../../../utils/withPermission';
import Swal from 'sweetalert2';
import { FaFilter } from "react-icons/fa";

// const BankDetailList = () => {
//     const [banks, setBanks] = useState([]);
//     const [showModal, setShowModal] = useState(false);
//     const [isLoading, setIsLoading] = useState(false);
//     const [selectedBankId, setSelectedBankId] = useState(null);
//     const [selectedBankData, setSelectedBankData] = useState(null);
//     const [currentPage, setCurrentPage] = useState(0);
//     const [pageCount, setPageCount] = useState(0);
//     const [errors, setErrors] = useState('');
//     const [searchQuery, setSearchQuery] = useState('');
//     const debounceTimeoutRef = useRef(null);
//     const firstLoad = useRef(true);
//     const { roles, permissions } = useAuth();
//     const [allBanks, setAllBanks] = useState([]);
//     const [countries, setCountries] = useState([]);
//     const [typeFilter, setTypeFilter] = useState('');
//     const [filterDropdown, setFilterDropdown] = useState(null);

//     // Exchange rate state
//     const [exchangeRate, setExchangeRate] = useState(3.692); // Default AED to USD rate

//     const fetchBanks = async (page = 1) => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;

//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');

//             const token = userInfo?.token;
//             let params = { page };
//             if (typeFilter) params.type = typeFilter;
//             if (searchQuery) params.search = searchQuery;
//             const response = await axios.get(`${backendUrl}/api/bank-accounts`, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 params,
//             });

//             const { data, current_page, last_page } = response.data.account;

//             setBanks(data);
//             setCurrentPage(current_page - 1);
//             setPageCount(last_page);
//         } catch (error) {
//             console.error('Error fetching banks:', error);
//         }
//     };

//     const [bankLedgers, setBankLedgers] = useState([]);
//     const [cashInHandLedgers, setCashInHandLedgers] = useState([]);
//     const [totalBalance, setTotalBalance] = useState(0);
//     const [totalCashBalance, setTotalCashBalance] = useState(0);
//     const [totalAssetBalance, setTotalAssetBalance] = useState(0);
//     const [payableBalance, setPayableBalance] = useState(0);
//     const [actualBalance, setActualBalance] = useState(0);

//     // Calculate USD balances
//     const totalBalanceUSD = totalBalance / exchangeRate;
//     const totalCashBalanceUSD = totalCashBalance / exchangeRate;
//     const totalAssetBalanceUSD = totalAssetBalance / exchangeRate;
//     const payableBalanceUSD = payableBalance / exchangeRate;
//     const actualBalanceUSD = actualBalance / exchangeRate;

// // const fetchAssets = async () => {
// //     try {
// //         const Api = process.env.REACT_APP_WEBZASH_URL;
// //         const apiKey = process.env.REACT_APP_API_KEY;

// //         // Fetch balance sheet data
// //         const responseLedger = await axios.get(`${Api}/api/reports/balancesheet`, {
// //             headers: { 'x-api-key': apiKey, 'Accept': 'application/json' },
// //         });

// //         console.log('Balance Sheet Data:', responseLedger.data.data);

// //         const assets = responseLedger.data.data.assets || [];
// //         const liabilities = responseLedger.data.data.liabilities || [];

// //         // Find Bank Accounts
// //         const bankAsset = assets.find(
// //             (asset) => asset.name === 'Bank Accounts'
// //         );

// //         // Find Cash in Hand
// //         const cashInHandAsset = assets.find(
// //             (asset) => asset.name === 'Cash-in-Hand'
// //         );

// //         // Find Payable Liabilities
// //         // These could include: Sundry Creditors (Vendors), Loans (Liabilities), etc.
// //         const sundryCreditors = liabilities.find(
// //             (liability) => liability.name === 'Sundry Creditors (Vendors)'
// //         );

// //         const loansLiabilities = liabilities.find(
// //             (liability) => liability.name === 'Loans (Liabilities)'
// //         );

// //         const currentLiabilities = liabilities.find(
// //             (liability) => liability.name === 'Current Liabilities'
// //         );

// //         const dutiesAndTaxes = liabilities.find(
// //             (liability) => liability.name === 'Duties and Taxes'
// //         );

// //         console.log('Bank Asset:', bankAsset);
// //         console.log('Cash in Hand Asset:', cashInHandAsset);
// //         console.log('Sundry Creditors:', sundryCreditors);
// //         console.log('Loans Liabilities:', loansLiabilities);

// //         let bankTotal = 0;
// //         let cashTotal = 0;
// //         let assetTotal = 0;
// //         let payableTotal = 0;

// //         // Calculate Bank Assets
// //         if (bankAsset && bankAsset.children) {
// //             console.log('Bank Children:', bankAsset.children);

// //             const bankItems = bankAsset.children.map(bank => {
// //                 const amount = parseFloat(bank.amount || 0);
// //                 // For ASSETS: Debit (D) = positive, Credit (C) = negative
// //                 const signedAmount = bank.dc === 'D' ? amount : -amount;

// //                 console.log(`Bank: ${bank.name}, Amount: ${amount}, DC: ${bank.dc}, Signed: ${signedAmount}`);

// //                 return {
// //                     ...bank,
// //                     signedAmount: signedAmount,
// //                     displayAmount: Math.abs(amount),
// //                     isDebit: bank.dc === 'D',
// //                     isCredit: bank.dc === 'C',
// //                     rawAmount: amount,
// //                     dc: bank.dc
// //                 };
// //             });

// //             setBankLedgers(bankItems);
// //             bankTotal = bankItems.reduce((sum, bank) => sum + bank.signedAmount, 0);
// //             setTotalBalance(bankTotal);

// //             console.log('Calculated Bank Total:', bankTotal);
// //         }

// //         // Calculate Cash Assets
// //         if (cashInHandAsset && cashInHandAsset.children) {
// //             console.log('Cash Children:', cashInHandAsset.children);

// //             const cashItems = cashInHandAsset.children.map(cash => {
// //                 const amount = parseFloat(cash.amount || 0);
// //                 // For ASSETS: Debit (D) = positive, Credit (C) = negative
// //                 const signedAmount = cash.dc === 'D' ? amount : -amount;

// //                 console.log(`Cash: ${cash.name}, Amount: ${amount}, DC: ${cash.dc}, Signed: ${signedAmount}`);

// //                 return {
// //                     ...cash,
// //                     signedAmount: signedAmount,
// //                     displayAmount: Math.abs(amount),
// //                     isDebit: cash.dc === 'D',
// //                     isCredit: cash.dc === 'C',
// //                     rawAmount: amount,
// //                     dc: cash.dc
// //                 };
// //             });

// //             setCashInHandLedgers(cashItems);
// //             cashTotal = cashItems.reduce((sum, cash) => sum + cash.signedAmount, 0);
// //             setTotalCashBalance(cashTotal);

// //             console.log('Calculated Cash Total:', cashTotal);
// //         }

// //         // Calculate Total Payables from Liabilities
// //         // For LIABILITIES: Credit (C) = positive (you owe money), Debit (D) = negative
// //         const calculateLiabilityTotal = (liability) => {
// //             if (!liability || !liability.children) return 0;

// //             return liability.children.reduce((sum, item) => {
// //                 const amount = parseFloat(item.amount || 0);
// //                 // For LIABILITIES: Credit (C) = positive (you owe), Debit (D) = negative
// //                 const signedAmount = item.dc === 'C' ? amount : -amount;
// //                 return sum + signedAmount;
// //             }, 0);
// //         };

// //         // Calculate total payables
// //         payableTotal = 
// //             calculateLiabilityTotal(sundryCreditors) +
// //             calculateLiabilityTotal(loansLiabilities) +
// //             calculateLiabilityTotal(currentLiabilities) +
// //             calculateLiabilityTotal(dutiesAndTaxes);

// //         setPayableBalance(payableTotal);
// //         console.log('Total Payables (Liabilities):', payableTotal);

// //         // Calculate total asset balance (Bank + Cash)
// //         assetTotal = bankTotal + cashTotal;
// //         setTotalAssetBalance(assetTotal);

// //         console.log('Total Asset Balance (Bank + Cash):', assetTotal);

// //         // Actual balance = total assets (bank + cash) - total payables
// //         const actualBal = assetTotal - payableTotal;
// //         setActualBalance(actualBal);

// //         console.log('Actual Available Balance:', actualBal);

// //     } catch (error) {
// //         console.error('Error fetching assets or expenses:', error);
// //     }
// // };
// const fetchAssets = async () => {
//     try {
//         const Api = process.env.REACT_APP_WEBZASH_URL;
//         const apiKey = process.env.REACT_APP_API_KEY;

//         // Step 1: Fetch all groups to find Bank Accounts and Cash-in-Hand
//         const groupsResponse = await axios.get(`${Api}/api/groups`, {
//             headers: { 'x-api-key': apiKey, 'Accept': 'application/json' },
//         });

//         console.log('Groups API Response:', groupsResponse.data);

//         // The response structure might be different - let's check it
//         const groupsData = groupsResponse.data.data || groupsResponse.data || [];
//         console.log('Groups Data Structure:', groupsData);

//         // Extract the Group objects from the array
//         let allGroups = [];
//         if (Array.isArray(groupsData) && groupsData.length > 0) {
//             // Check if the structure is [{Group: {...}}, {Group: {...}}]
//             if (groupsData[0] && groupsData[0].Group) {
//                 allGroups = groupsData.map(item => item.Group);
//             } else {
//                 // If it's already flat structure
//                 allGroups = groupsData;
//             }
//         }

//         console.log('Processed Groups:', allGroups);

//         // Find Bank Accounts and Cash-in-Hand group IDs
//         const bankGroup = allGroups.find(group => 
//             group.name === 'Bank Accounts'
//         );
//         const cashGroup = allGroups.find(group => 
//             group.name === 'Cash-in-Hand'
//         );

//         console.log('Bank Group Found:', bankGroup);
//         console.log('Cash Group Found:', cashGroup);

//         let bankTotal = 0;
//         let cashTotal = 0;
//         let bankLedgersList = [];
//         let cashLedgersList = [];

//         // Step 2: Fetch bank ledgers using the new API endpoint
//         if (bankGroup?.id) {
//             try {
//                 console.log('Fetching bank ledgers for group ID:', bankGroup.id);

//                 // Try the new endpoint first
//                 const bankLedgersResponse = await axios.get(
//                     `${Api}/api/ledgers/getByGroupId/${bankGroup.id}`,
//                     {
//                         headers: { 'x-api-key': apiKey, 'Accept': 'application/json' },
//                     }
//                 );

//                 console.log('Bank Ledgers API Response:', bankLedgersResponse.data);

//                 if (bankLedgersResponse.data.status === 'success') {
//                     const bankLedgersData = bankLedgersResponse.data.data || [];
//                     console.log('Bank Ledgers Data:', bankLedgersData);

//                     bankLedgersList = bankLedgersData.map((ledger) => {
//                         // Check if ledger has current_balance field
//                         let amount = 0;
//                         let dc = 'D';

//                         if (ledger.current_balance !== undefined && ledger.current_balance_dc !== undefined) {
//                             amount = parseFloat(ledger.current_balance || 0);
//                             dc = ledger.current_balance_dc || 'D';
//                         } else if (ledger.op_balance !== undefined && ledger.op_balance_dc !== undefined) {
//                             // Fallback to opening balance if current balance not available
//                             amount = parseFloat(ledger.op_balance || 0);
//                             dc = ledger.op_balance_dc || 'D';
//                         }

//                         // For ASSETS: Debit (D) = positive, Credit (C) = negative
//                         const signedAmount = dc === 'D' ? amount : -amount;

//                         console.log(`Bank Ledger: ${ledger.name}, Amount: ${amount}, DC: ${dc}, Signed: ${signedAmount}`);

//                         return {
//                             id: ledger.id,
//                             name: ledger.name,
//                             signedAmount: signedAmount,
//                             displayAmount: Math.abs(amount),
//                             isDebit: dc === 'D',
//                             isCredit: dc === 'C',
//                             rawAmount: amount,
//                             dc: dc,
//                             ledgerData: ledger,
//                             groupName: bankLedgersResponse.data.group?.name || 'Bank Accounts'
//                         };
//                     });

//                     bankTotal = bankLedgersList.reduce((sum, bank) => sum + bank.signedAmount, 0);
//                     setBankLedgers(bankLedgersList);
//                     setTotalBalance(bankTotal);

//                     console.log('Bank Ledgers loaded via API:', bankLedgersList.length);
//                     console.log('Bank Total:', bankTotal);
//                 } else {
//                     // If API returns error, use fallback
//                     console.log('Bank API returned error, using fallback');
//                     await fetchLedgersByStatement(bankGroup.id, 'bank');
//                 }
//             } catch (error) {
//                 console.error('Error using getByGroupId API for bank:', error);
//                 console.log('Error details:', error.response?.data || error.message);
//                 // Fallback to alternative method
//                 await fetchLedgersByStatement(bankGroup.id, 'bank');
//             }
//         } else {
//             console.log('No Bank Accounts group found');
//         }

//         // Step 3: Fetch cash ledgers using the new API endpoint
//         if (cashGroup?.id) {
//             try {
//                 console.log('Fetching cash ledgers for group ID:', cashGroup.id);

//                 // Try the new endpoint first
//                 const cashLedgersResponse = await axios.get(
//                     `${Api}/api/ledgers/getByGroupId/${cashGroup.id}`,
//                     {
//                         headers: { 'x-api-key': apiKey, 'Accept': 'application/json' },
//                     }
//                 );

//                 console.log('Cash Ledgers API Response:', cashLedgersResponse.data);

//                 if (cashLedgersResponse.data.status === 'success') {
//                     const cashLedgersData = cashLedgersResponse.data.data || [];
//                     console.log('Cash Ledgers Data:', cashLedgersData);

//                     cashLedgersList = cashLedgersData.map((ledger) => {
//                         // Check if ledger has current_balance field
//                         let amount = 0;
//                         let dc = 'D';

//                         if (ledger.current_balance !== undefined && ledger.current_balance_dc !== undefined) {
//                             amount = parseFloat(ledger.current_balance || 0);
//                             dc = ledger.current_balance_dc || 'D';
//                         } else if (ledger.op_balance !== undefined && ledger.op_balance_dc !== undefined) {
//                             // Fallback to opening balance if current balance not available
//                             amount = parseFloat(ledger.op_balance || 0);
//                             dc = ledger.op_balance_dc || 'D';
//                         }

//                         // For ASSETS: Debit (D) = positive, Credit (C) = negative
//                         const signedAmount = dc === 'D' ? amount : -amount;

//                         console.log(`Cash Ledger: ${ledger.name}, Amount: ${amount}, DC: ${dc}, Signed: ${signedAmount}`);

//                         return {
//                             id: ledger.id,
//                             name: ledger.name,
//                             signedAmount: signedAmount,
//                             displayAmount: Math.abs(amount),
//                             isDebit: dc === 'D',
//                             isCredit: dc === 'C',
//                             rawAmount: amount,
//                             dc: dc,
//                             ledgerData: ledger,
//                             groupName: cashLedgersResponse.data.group?.name || 'Cash-in-Hand'
//                         };
//                     });

//                     cashTotal = cashLedgersList.reduce((sum, cash) => sum + cash.signedAmount, 0);
//                     setCashInHandLedgers(cashLedgersList);
//                     setTotalCashBalance(cashTotal);

//                     console.log('Cash Ledgers loaded via API:', cashLedgersList.length);
//                     console.log('Cash Total:', cashTotal);
//                 } else {
//                     // If API returns error, use fallback
//                     console.log('Cash API returned error, using fallback');
//                     await fetchLedgersByStatement(cashGroup.id, 'cash');
//                 }
//             } catch (error) {
//                 console.error('Error using getByGroupId API for cash:', error);
//                 console.log('Error details:', error.response?.data || error.message);
//                 // Fallback to alternative method
//                 await fetchLedgersByStatement(cashGroup.id, 'cash');
//             }
//         } else {
//             console.log('No Cash-in-Hand group found');
//         }

//         // Step 4: Calculate totals
//         const assetTotal = bankTotal + cashTotal;
//         setTotalAssetBalance(assetTotal);

//         console.log('Total Asset Balance (Bank + Cash):', assetTotal);

//         // Step 5: Fetch payable liabilities
//         await fetchPayableLiabilities();

//         // Step 6: Calculate actual available balance
//         const actualBal = assetTotal - payableBalance;
//         setActualBalance(actualBal);

//         console.log('Actual Available Balance:', actualBal);

//     } catch (error) {
//         console.error('Error in fetchAssets:', error);
//         console.log('Error details:', error.response?.data || error.message);
//         // Final fallback to balance sheet method
//         await fetchAssetsFromBalanceSheet();
//     }
// };

// // Fallback method to fetch ledgers using ledger statement API
// const fetchLedgersByStatement = async (groupId, type = 'bank') => {
//     try {
//         const Api = process.env.REACT_APP_WEBZASH_URL;
//         const apiKey = process.env.REACT_APP_API_KEY;

//         console.log(`Fetching ${type} ledgers via fallback method for group ID:`, groupId);

//         // First get all ledgers
//         const allLedgersResponse = await axios.get(`${Api}/api/ledgers`, {
//             headers: { 'x-api-key': apiKey, 'Accept': 'application/json' },
//         });

//         console.log('All Ledgers Response:', allLedgersResponse.data);

//         const ledgersData = allLedgersResponse.data.data || allLedgersResponse.data || [];
//         let allLedgers = [];

//         // Extract ledger objects from response
//         if (Array.isArray(ledgersData) && ledgersData.length > 0) {
//             if (ledgersData[0] && ledgersData[0].Ledger) {
//                 allLedgers = ledgersData.map(item => item.Ledger);
//             } else {
//                 allLedgers = ledgersData;
//             }
//         }

//         console.log('Processed All Ledgers:', allLedgers);

//         // Filter ledgers by group_id
//         const filteredLedgers = allLedgers.filter(ledger => ledger.group_id == groupId);

//         console.log(`Found ${filteredLedgers.length} ${type} ledgers via filtering`);

//         if (filteredLedgers.length > 0) {
//             await processLedgersWithStatement(filteredLedgers, type);
//             return;
//         } else {
//             console.log(`No ledgers found for group ID ${groupId}, trying search...`);

//             // Try to get group name and search by that
//             try {
//                 const groupsResponse = await axios.get(`${Api}/api/groups`, {
//                     headers: { 'x-api-key': apiKey, 'Accept': 'application/json' },
//                 });

//                 const groupsData = groupsResponse.data.data || groupsResponse.data || [];
//                 let groups = [];

//                 if (Array.isArray(groupsData) && groupsData.length > 0) {
//                     if (groupsData[0] && groupsData[0].Group) {
//                         groups = groupsData.map(item => item.Group);
//                     } else {
//                         groups = groupsData;
//                     }
//                 }

//                 const group = groups.find(g => g.id == groupId);

//                 if (group) {
//                     console.log(`Group found: ${group.name}, searching ledgers...`);

//                     // Search ledgers that might belong to this group by name pattern
//                     const searchTerms = type === 'bank' ? ['bank', 'account'] : ['cash', 'hand'];

//                     // Filter all ledgers by name containing search terms
//                     const searchedLedgers = allLedgers.filter(ledger => {
//                         const ledgerName = ledger.name.toLowerCase();
//                         return searchTerms.some(term => ledgerName.includes(term));
//                     });

//                     console.log(`Found ${searchedLedgers.length} ${type} ledgers via name search`);

//                     if (searchedLedgers.length > 0) {
//                         await processLedgersWithStatement(searchedLedgers, type);
//                         return;
//                     }
//                 }
//             } catch (searchError) {
//                 console.error('Error searching ledgers:', searchError);
//             }
//         }

//         console.log(`No ${type} ledgers found via fallback methods`);

//     } catch (error) {
//         console.error(`Error in fetchLedgersByStatement for ${type}:`, error);
//     }
// };

// const processLedgersWithStatement = async (ledgers, type) => {
//     const Api = process.env.REACT_APP_WEBZASH_URL;

//     // Update state based on type
//     if (type === 'bank') {
//         setBankLedgers(ledgerList);
//         setTotalBalance(total);
//         console.log(`Bank fallback complete: ${ledgerList.length} ledgers, total: ${total}`);
//     } else {
//         setCashInHandLedgers(ledgerList);
//         setTotalCashBalance(total);
//         console.log(`Cash fallback complete: ${ledgerList.length} ledgers, total: ${total}`);
//     }
// };

// // Function to fetch payable liabilities
// const fetchPayableLiabilities = async () => {
//     try {
//         const Api = process.env.REACT_APP_WEBZASH_URL;
//         const apiKey = process.env.REACT_APP_API_KEY;

//         console.log('Fetching payable liabilities...');

//         const response = await axios.get(`${Api}/api/reports/balancesheet`, {
//             headers: { 'x-api-key': apiKey, 'Accept': 'application/json' },
//         });

//         console.log('Balance Sheet Response:', response.data);

//         const liabilities = response.data.data?.liabilities || [];

//         // Find payable groups
//         const payableGroups = [
//             'Sundry Creditors (Vendors)',
//             'Loans (Liabilities)',
//             'Current Liabilities',
//             'Duties and Taxes',
//             'Creditors'
//         ];

//         let payableTotal = 0;

//         payableGroups.forEach(groupName => {
//             const liabilityGroup = liabilities.find(l => l.name === groupName);
//             if (liabilityGroup && liabilityGroup.children) {
//                 console.log(`Processing ${groupName}:`, liabilityGroup.children);

//                 liabilityGroup.children.forEach(item => {
//                     const amount = parseFloat(item.amount || 0);
//                     // For LIABILITIES: Credit (C) = positive (you owe), Debit (D) = negative
//                     const signedAmount = item.dc === 'C' ? amount : -amount;
//                     payableTotal += signedAmount;

//                     console.log(`  ${item.name}: ${amount} ${item.dc} (signed: ${signedAmount})`);
//                 });
//             }
//         });

//         setPayableBalance(payableTotal);
//         console.log('Payable Liabilities Total:', payableTotal);

//     } catch (error) {
//         console.error('Error fetching payable liabilities:', error);
//         setPayableBalance(0);
//     }
// };

// // Final fallback to balance sheet method
// const fetchAssetsFromBalanceSheet = async () => {
//     try {
//         const Api = process.env.REACT_APP_WEBZASH_URL;
//         const apiKey = process.env.REACT_APP_API_KEY;

//         console.log('Using Balance Sheet fallback method...');

//         const response = await axios.get(`${Api}/api/reports/balancesheet`, {
//             headers: { 'x-api-key': apiKey, 'Accept': 'application/json' },
//         });

//         console.log('Balance Sheet Data:', response.data);

//         const assets = response.data.data?.assets || [];

//         // Find Bank Accounts
//         const bankAsset = assets.find(
//             (asset) => asset.name === 'Bank Accounts'
//         );

//         // Find Cash in Hand
//         const cashInHandAsset = assets.find(
//             (asset) => asset.name === 'Cash-in-Hand'
//         );

//         console.log('Bank Asset from balance sheet:', bankAsset);
//         console.log('Cash Asset from balance sheet:', cashInHandAsset);

//         let bankTotal = 0;
//         let cashTotal = 0;
//         let bankLedgersList = [];
//         let cashLedgersList = [];

//         // Process Bank Accounts
//         if (bankAsset && bankAsset.children) {
//             bankLedgersList = bankAsset.children.map(bank => {
//                 const amount = parseFloat(bank.amount || 0);
//                 const signedAmount = bank.dc === 'D' ? amount : -amount;

//                 console.log(`Balance Sheet Bank: ${bank.name}, ${amount} ${bank.dc}`);

//                 return {
//                     id: bank.id,
//                     name: bank.name,
//                     signedAmount: signedAmount,
//                     displayAmount: Math.abs(amount),
//                     isDebit: bank.dc === 'D',
//                     isCredit: bank.dc === 'C',
//                     rawAmount: amount,
//                     dc: bank.dc
//                 };
//             });

//             bankTotal = bankLedgersList.reduce((sum, bank) => sum + bank.signedAmount, 0);
//             setBankLedgers(bankLedgersList);
//             setTotalBalance(bankTotal);
//         }

//         // Process Cash in Hand
//         if (cashInHandAsset && cashInHandAsset.children) {
//             cashLedgersList = cashInHandAsset.children.map(cash => {
//                 const amount = parseFloat(cash.amount || 0);
//                 const signedAmount = cash.dc === 'D' ? amount : -amount;

//                 console.log(`Balance Sheet Cash: ${cash.name}, ${amount} ${cash.dc}`);

//                 return {
//                     id: cash.id,
//                     name: cash.name,
//                     signedAmount: signedAmount,
//                     displayAmount: Math.abs(amount),
//                     isDebit: cash.dc === 'D',
//                     isCredit: cash.dc === 'C',
//                     rawAmount: amount,
//                     dc: cash.dc
//                 };
//             });

//             cashTotal = cashLedgersList.reduce((sum, cash) => sum + cash.signedAmount, 0);
//             setCashInHandLedgers(cashLedgersList);
//             setTotalCashBalance(cashTotal);
//         }

//         // Calculate totals
//         const assetTotal = bankTotal + cashTotal;
//         setTotalAssetBalance(assetTotal);

//         console.log('Balance sheet totals - Bank:', bankTotal, 'Cash:', cashTotal, 'Total:', assetTotal);

//         // Fetch payables
//         await fetchPayableLiabilities();

//         // Calculate actual balance
//         const actualBal = assetTotal - payableBalance;
//         setActualBalance(actualBal);

//         console.log('Balance sheet fallback completed. Actual Balance:', actualBal);

//     } catch (error) {
//         console.error('Error in final fallback (balance sheet):', error);
//         console.log('Error details:', error.response?.data || error.message);
//         // Set empty state
//         setBankLedgers([]);
//         setCashInHandLedgers([]);
//         setTotalBalance(0);
//         setTotalCashBalance(0);
//         setTotalAssetBalance(0);
//         setPayableBalance(0);
//         setActualBalance(0);
//     }
// };
//     const fetchExchangeRate = async () => {
//         try {
//             // You can replace this with your actual exchange rate API
//             // const response = await axios.get('https://api.exchangerate-api.com/v4/latest/AED');
//             // setExchangeRate(response.data.rates.USD);

//             setExchangeRate(3.692);
//         } catch (error) {
//             console.error('Error fetching exchange rate:', error);
//             setExchangeRate(3.692);
//         }
//     };

//     useEffect(() => {
//         fetchAssets();
//         fetchExchangeRate();
//     }, []);

//     const fetchCountries = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');

//             const token = userInfo?.token;

//             const response = await axios.get(`${backendUrl}/api/countries`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 skipLoader: true,
//             });

//             let countryList = response.data.Data;

//             countryList = countryList.sort((a, b) => (a.id === 231 ? -1 : b.id === 231 ? 1 : 0));

//             setCountries(countryList);
//         } catch (error) {
//             console.error('Error fetching countries:', error);
//         }
//     };

//     useEffect(() => {
//         if (debounceTimeoutRef.current) {
//             clearTimeout(debounceTimeoutRef.current);
//         }

//         debounceTimeoutRef.current = setTimeout(() => {
//             fetchBanks(1, searchQuery);
//         }, searchQuery ? 1500 : 0);

//         return () => {
//             if (debounceTimeoutRef.current) {
//                 clearTimeout(debounceTimeoutRef.current);
//             }
//         };
//     }, [searchQuery, typeFilter]);

//     const handleSearchChange = (e) => {
//         setSearchQuery(e.target.value);
//     };

//     const WithDeletePermission = withPermission(({ children }) => children, ['bankaccount-delete']);
//     const WithEditPermission = withPermission(({ children }) => children, ['bankaccount-edit']);
//     const WithCreatePermission = withPermission(({ children }) => children, ['bankaccount-create']);

//     const addBank = async (newBank) => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;

//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.post(`${backendUrl}/api/bank-accounts`, newBank, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//             });
//             const createdBank = response.data?.account;
//             if (createdBank) {
//                 setBanks((prevBanks) => [...prevBanks, createdBank]);
//             } else {
//                 console.error('Creation failed, no data returned.');
//             }

//             handleCloseModal();
//         } catch (error) {
//             if (error.response?.data?.errors) {
//                 return error.response.data.errors;
//             } else {
//                 console.error('Error adding bank:', error);
//             }
//         }
//     };

//     const editBank = async (bankId, updatedData) => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;

//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.put(`${backendUrl}/api/bank-accounts/${bankId}`, updatedData, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//             });
//             const updatedBank = response.data?.account;

//             if (updatedBank) {
//                 setBanks((prevBanks) =>
//                     prevBanks.map((bank) =>
//                         bank.id === updatedBank.id ? updatedBank : bank
//                     )
//                 );
//             } else {
//                 console.error('Update failed, no data returned.');
//             }

//             handleCloseModal();
//         } catch (error) {
//             if (error.response?.data?.errors) {
//                 return error.response.data.errors;
//             } else {
//                 console.error('Error updating bank:', error);
//             }
//         }
//     };

//     const deleteBank = async (id) => {
//         Swal.fire({
//             title: "Are you sure?",
//             text: "You won't be able to revert this!",
//             icon: "warning",
//             showCancelButton: true,
//             confirmButtonColor: "#d33",
//             cancelButtonColor: "#3085d6",
//             confirmButtonText: "Yes, delete it!"
//         }).then(async (result) => {
//             if (result.isConfirmed) {
//                 try {
//                     const backendUrl = process.env.REACT_APP_BACKEND_URL;

//                     const userInfo = JSON.parse(localStorage.getItem('user-info'));
//                     const origin = localStorage.getItem('user-origin');
//                     const token = userInfo?.token;

//                     await axios.delete(`${backendUrl}/api/bank-accounts/${id}`, {
//                         headers: {
//                             'Authorization': `Bearer ${token}`,
//                             'Tenant-Origin': origin,
//                         },
//                     });

//                     setBanks(banks.filter(bank => bank.id !== id));
//                     Swal.fire(
//                         "Deleted!",
//                         "The bank has been deleted.",
//                         "success"
//                     );
//                 } catch (error) {
//                     console.error('Error deleting bank:', error);
//                     Swal.fire(
//                         "Error!",
//                         "Failed to delete bank. Please try again.",
//                         "error"
//                     );
//                 }
//             }
//         });
//     };

//     const handleShowModal = (bankId = null) => {
//         if (bankId) {
//             const bankToEdit = banks.find(bank => bank.id === bankId);
//             if (bankToEdit) {
//                 setSelectedBankData(bankToEdit);
//             }
//         } else {
//             setSelectedBankData(null);
//         }
//         setSelectedBankId(bankId);
//         setShowModal(true);
//     };

//     const handleCloseModal = () => {
//         setShowModal(false);
//         setSelectedBankId(null);
//         setSelectedBankData(null);
//         setErrors({});
//     };

//     const handlePageClick = (data) => {
//         const selectedPage = data.selected + 1;
//         fetchBanks(selectedPage);
//     };

//     const handleFilterChange = (filterType, value) => {
//         if (filterType === 'type') setTypeFilter(value);
//         setFilterDropdown(null);
//     };

//     const handleImport = async (event) => {
//         const file = event.target.files[0];
//         if (!file) return;

//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const formData = new FormData();
//             formData.append('file', file);

//             const response = await axios.post(
//                 `${backendUrl}/api/bank-accounts/import`,
//                 formData,
//                 {
//                     headers: {
//                         Authorization: `Bearer ${token}`,
//                         'Content-Type': 'multipart/form-data',
//                         'Tenant-Origin': origin,
//                     },
//                 }
//             );

//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'success',
//                 title: response.data.message || ` Imported successfully!`,
//                 timer: 3000,
//                 timerProgressBar: false,
//                 showConfirmButton: false,
//                 didOpen: () => {
//                     const container = Swal.getContainer();
//                     container.style.top = '50px';
//                 },
//             });

//             setTimeout(() => window.location.reload(), 1000);
//             event.target.value = '';

//         } catch (error) {
//             console.error('Import error:', error);
//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'error',
//                 title: error.response?.data?.errors || error.response?.errors || `Failed to import instance information`,
//                 timer: 3000,
//                 timerProgressBar: false,
//                 showConfirmButton: false,
//                 didOpen: () => {
//                     const container = Swal.getContainer();
//                     container.style.top = '50px';
//                 },
//             });
//             event.target.value = "";
//         } finally {
//         }
//     };

//     const handleExport = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.get(
//                 `${backendUrl}/api/bank-accounts/export`,
//                 {
//                     headers: {
//                         Authorization: `Bearer ${token}`,
//                         'Tenant-Origin': origin,
//                     },
//                     responseType: 'blob',
//                 }
//             );

//             const blob = new Blob([response.data]);
//             const url = window.URL.createObjectURL(blob);
//             const link = document.createElement('a');
//             link.href = url;

//             const contentDisposition = response.headers['content-disposition'];
//             let filename = `BankAccounts_${new Date().toISOString().split('T')[0]}.xlsx`;

//             if (contentDisposition) {
//                 const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
//                 if (filenameMatch.length === 2) {
//                     filename = filenameMatch[1];
//                 }
//             }

//             link.setAttribute('download', filename);
//             document.body.appendChild(link);
//             link.click();
//             link.remove();
//             window.URL.revokeObjectURL(url);

//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'success',
//                 title: `Exported successfully!`,
//                 timer: 2000,
//                 timerProgressBar: false,
//                 showConfirmButton: false,
//                 didOpen: () => {
//                     const container = Swal.getContainer();
//                     container.style.top = '50px';
//                 },
//             });

//         } catch (error) {
//             console.error('Export error:', error);
//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'error',
//                 title: `Failed to export`,
//                 timer: 3000,
//                 timerProgressBar: false,
//                 showConfirmButton: false,
//                 didOpen: () => {
//                     const container = Swal.getContainer();
//                     container.style.top = '50px';
//                 },
//             });
//         } finally {
//         }
//     };

//     const formatCurrency = (amount, currency = 'AED') => {
//         return parseFloat(amount || 0).toLocaleString("en-US", {
//             minimumFractionDigits: 2,
//             maximumFractionDigits: 2
//         });
//     };

//     const renderLedgerItems = (ledgers, title) => {
//         if (ledgers.length === 0) return null;

//         return (
//             <>
//                 <tr className="category-header">
//                     <td colSpan="5">
//                         <strong>{title}</strong>
//                     </td>
//                 </tr>
//                 {ledgers.map((item, index) => {
//                     const balanceAED = item.signedAmount; // This is now signed (+ or -)
//                     const balanceUSD = balanceAED / exchangeRate;

//                     return (
//                         <tr key={`${title}-${index}`} className="asset-item">
//                             <td>
//                                 <div className="form-check font-size-16">
//                                     <input
//                                         className="form-check-input"
//                                         type="checkbox"
//                                         id={`${title}-check-${index}`}
//                                     />
//                                 </div>
//                             </td>
//                             <td>
//                                 <div className="serial-number">{index + 1}</div>
//                             </td>
//                             <td>
//                                 <div className="asset-info">
//                                     <div className="asset-name">{item.name}</div>

//                                 </div>
//                             </td>
//                             <td className="text-end">
//                                 <div className="balance-container">
//                                     <div className={`balance-figure ${balanceAED >= 0 ? 'text-dark' : 'text-dark'}`}>
//                                         {formatCurrency(Math.abs(balanceAED))} AED
//                                     </div>

//                                 </div>
//                             </td>
//                             <td className="text-end">
//                                 <div className="balance-container">
//                                     <div className={`balance-figure ${balanceUSD >= 0 ? 'text-dark' : 'text-dark'}`}>
//                                         {formatCurrency(Math.abs(balanceUSD))} USD
//                                     </div>
//                                 </div>
//                             </td>
//                         </tr>
//                     );
//                 })}
//             </>
//         );
//     };

//     return (
//         <div className="main-content">
//             <div className="page-content">
//                 <div className="container-fluid">
//                     <div className="row">
//                         <div className="col-12">
//                             <div className="page-title-box d-sm-flex align-items-center justify-content-between">
//                                 <h4 className="mb-sm-0 font-size-18">Assets - Bank & Cash</h4>
//                             </div>
//                         </div>
//                     </div>

//                     <div className="row mb-3">
//                         <div className="col-12">
//                             <div className="alert alert-info">
//                                 <div className="d-flex justify-content-between align-items-center">
//                                     <div>
//                                         <strong>Exchange Rate:</strong> 1 AED = {exchangeRate.toFixed(4)} USD
//                                     </div>
//                                     <div>
//                                         <button
//                                             className="btn btn-sm btn-outline-primary"
//                                             onClick={() => {
//                                                 Swal.fire({
//                                                     title: 'Update Exchange Rate',
//                                                     input: 'number',
//                                                     inputValue: exchangeRate,
//                                                     inputAttributes: {
//                                                         step: "0.0001",
//                                                         min: "0.0001"
//                                                     },
//                                                     showCancelButton: true,
//                                                     confirmButtonText: 'Update',
//                                                     cancelButtonText: 'Cancel',
//                                                     showLoaderOnConfirm: true,
//                                                     preConfirm: (rate) => {
//                                                         if (!rate || rate <= 0) {
//                                                             Swal.showValidationMessage('Please enter a valid exchange rate');
//                                                         }
//                                                         return parseFloat(rate);
//                                                     }
//                                                 }).then((result) => {
//                                                     if (result.isConfirmed) {
//                                                         setExchangeRate(result.value);
//                                                         Swal.fire({
//                                                             toast: true,
//                                                             position: 'top-end',
//                                                             icon: 'success',
//                                                             title: 'Exchange rate updated',
//                                                             timer: 2000,
//                                                             showConfirmButton: false
//                                                         });
//                                                     }
//                                                 });
//                                             }}
//                                         >
//                                             Update Rate
//                                         </button>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     <div className="row">
//                         <div className="col-12">
//                             <div className="card">
//                                 <div className="card-body">
//                                     <div className="d-flex justify-content-between mb-3">
//                                         <div className="d-flex">
//                                             <div className="search-box me-2 mb-2 d-inline-block">
//                                                 <div className="position-relative">
//                                                     <input
//                                                         type="text"
//                                                         className="form-control font-size-12"
//                                                         placeholder="Search assets..."
//                                                         value={searchQuery}
//                                                         onChange={handleSearchChange}
//                                                     />
//                                                     <i className="bx bx-search-alt search-icon" />
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>

//                                     <div>
//                                         <table className="table align-middle table-nowrap table-check table-list">
//                                             <thead className="table-light">
//                                                 <tr>
//                                                     <th style={{ width: '20px' }} className="align-middle">
//                                                         <div className="form-check font-size-16">
//                                                             <input className="form-check-input" type="checkbox" id="checkAll" />
//                                                             <label className="form-check-label" htmlFor="checkAll"></label>
//                                                         </div>
//                                                     </th>
//                                                     <th className="align-middle">#</th>
//                                                     <th>Account Name</th>
//                                                     <th className="text-end">Balance (AED)</th>
//                                                     <th className="text-end">Balance (USD)</th>
//                                                 </tr>
//                                             </thead>

//                                             <tbody>
//                                                 {bankLedgers.length === 0 && cashInHandLedgers.length === 0 ? (
//                                                     <tr>
//                                                         <td colSpan="5" className="text-center py-5">
//                                                             <div className="no-data">
//                                                                 <i className="mdi mdi-database-remove-outline display-4 text-light"></i>
//                                                                 <h6 className="mt-3 text-muted">No assets available</h6>
//                                                             </div>
//                                                         </td>
//                                                     </tr>
//                                                 ) : (
//                                                     <>
//                                                         {renderLedgerItems(bankLedgers, 'Bank Accounts')}
//                                                         {renderLedgerItems(cashInHandLedgers, 'Cash in Hand')}

//                                                         {/* Bank Accounts Summary */}
//                                                         {bankLedgers.length > 0 && (
//                                                             <tr className="summary-row category-total">
//                                                                 <td colSpan={3}>
//                                                                     <strong>Total Bank Accounts</strong>
//                                                                 </td>
//                                                                 <td className="text-end">
//                                                                     <strong className={totalBalance >= 0 ? 'text-success' : 'text-danger'}>
//                                                                         {formatCurrency(Math.abs(totalBalance))} AED
//                                                                         {totalBalance < 0 && ' (CR)'}
//                                                                     </strong>
//                                                                 </td>
//                                                                 <td className="text-end">
//                                                                     <strong className={totalBalanceUSD >= 0 ? 'text-success' : 'text-danger'}>
//                                                                         {formatCurrency(Math.abs(totalBalanceUSD))} USD
//                                                                         {totalBalanceUSD < 0 && ' (CR)'}
//                                                                     </strong>
//                                                                 </td>
//                                                             </tr>
//                                                         )}

//                                                         {/* Cash in Hand Summary */}
//                                                         {cashInHandLedgers.length > 0 && (
//                                                             <tr className="summary-row category-total">
//                                                                 <td colSpan={3}>
//                                                                     <strong>Total Cash in Hand</strong>
//                                                                 </td>
//                                                                 <td className="text-end">
//                                                                     <strong className={totalCashBalance >= 0 ? 'text-success' : 'text-danger'}>
//                                                                         {formatCurrency(Math.abs(totalCashBalance))} AED
//                                                                         {totalCashBalance < 0 && ' (CR)'}
//                                                                     </strong>
//                                                                 </td>
//                                                                 <td className="text-end">
//                                                                     <strong className={totalCashBalanceUSD >= 0 ? 'text-success' : 'text-danger'}>
//                                                                         {formatCurrency(Math.abs(totalCashBalanceUSD))} USD
//                                                                         {totalCashBalanceUSD < 0 && ' (CR)'}
//                                                                     </strong>
//                                                                 </td>
//                                                             </tr>
//                                                         )}

//                                                         {/* Total Assets Summary */}
//                                                         <tr className="summary-row total-assets">
//                                                             <td colSpan={3}>
//                                                                 <strong>Total Assets (Bank + Cash)</strong>
//                                                             </td>
//                                                             <td className="text-end">
//                                                                 <strong className={totalAssetBalance >= 0 ? 'text-success' : 'text-danger'}>
//                                                                     {formatCurrency(Math.abs(totalAssetBalance))} AED
//                                                                     {totalAssetBalance < 0 && ' (CR)'}
//                                                                 </strong>
//                                                             </td>
//                                                             <td className="text-end">
//                                                                 <strong className={totalAssetBalanceUSD >= 0 ? 'text-success' : 'text-danger'}>
//                                                                     {formatCurrency(Math.abs(totalAssetBalanceUSD))} USD
//                                                                     {totalAssetBalanceUSD < 0 && ' (CR)'}
//                                                                 </strong>
//                                                             </td>
//                                                         </tr>

//                                                         {/* Payable Expenses */}
//                                                         {payableBalance > 0 && (
//                                                             <tr className="summary-row payable">
//                                                                 <td colSpan={3}>
//                                                                     <span className="text-danger">Payable Expenses</span>
//                                                                 </td>
//                                                                 <td className="text-end text-danger">
//                                                                     {formatCurrency(payableBalance)} AED
//                                                                 </td>
//                                                                 <td className="text-end text-danger">
//                                                                     {formatCurrency(payableBalanceUSD)} USD
//                                                                 </td>
//                                                             </tr>
//                                                         )}

//                                                         {/* Net Available Balance */}
//                                                         <tr className="summary-row available">
//                                                             <td colSpan={3}>
//                                                                 <span className="text-success">Net Available Balance</span>
//                                                             </td>
//                                                             <td className="text-end text-success">
//                                                                 <strong>{formatCurrency(actualBalance)} AED</strong>
//                                                             </td>
//                                                             <td className="text-end text-success">
//                                                                 <strong>{formatCurrency(actualBalanceUSD)} USD</strong>
//                                                             </td>
//                                                         </tr>
//                                                     </>
//                                                 )}
//                                             </tbody>
//                                         </table>

//                                         <div className="d-flex justify-content-end pagination-sm">
//                                             <ReactPaginate
//                                                 previousLabel={'<'}
//                                                 nextLabel={'>'}
//                                                 breakLabel={'...'}
//                                                 pageCount={pageCount}
//                                                 marginPagesDisplayed={2}
//                                                 pageRangeDisplayed={3}
//                                                 onPageChange={handlePageClick}
//                                                 containerClassName={'pagination pagination-rounded justify-content-end mb-2'}
//                                                 pageClassName={'page-item'}
//                                                 pageLinkClassName={'page-link'}
//                                                 previousClassName={'page-item previous'}
//                                                 previousLinkClassName={'page-link'}
//                                                 nextClassName={'page-item next'}
//                                                 nextLinkClassName={'page-link'}
//                                                 breakClassName={'page-item'}
//                                                 breakLinkClassName={'page-link'}
//                                                 activeClassName={'active'}
//                                             />
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     <BankModal
//                         key={selectedBankId || 'new'}
//                         showModal={showModal}
//                         handleClose={handleCloseModal}
//                         bankId={selectedBankId}
//                         bankData={selectedBankData}
//                         addBank={addBank}
//                         editBank={editBank}
//                         banks={banks}
//                         errors={errors}
//                         setErrors={setErrors}
//                         countries={countries}
//                         fetchCountries={fetchCountries}
//                     />
//                 </div>
//             </div>
//         </div>
//     );
// };


const BankDetailList = () => {
    const [banks, setBanks] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedBankId, setSelectedBankId] = useState(null);
    const [selectedBankData, setSelectedBankData] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [errors, setErrors] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const debounceTimeoutRef = useRef(null);
    const firstLoad = useRef(true);
    const { roles, permissions } = useAuth();
    const [allBanks, setAllBanks] = useState([]);
    const [countries, setCountries] = useState([]);
    const [typeFilter, setTypeFilter] = useState('');
    const [filterDropdown, setFilterDropdown] = useState(null);

    // Exchange rate state
    const [exchangeRate, setExchangeRate] = useState(3.692); // Default AED to USD rate

    const fetchBanks = async (page = 1) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;

            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;
            let params = { page };
            if (typeFilter) params.type = typeFilter;
            if (searchQuery) params.search = searchQuery;
            const response = await axios.get(`${backendUrl}/api/bank-accounts`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                params,
            });

            const { data, current_page, last_page } = response.data.account;

            setBanks(data);
            setCurrentPage(current_page - 1);
            setPageCount(last_page);
        } catch (error) {
            console.error('Error fetching banks:', error);
        }
    };

    const [bankLedgers, setBankLedgers] = useState([]);
    const [cashInHandLedgers, setCashInHandLedgers] = useState([]);
    const [totalBalance, setTotalBalance] = useState(0);
    const [totalCashBalance, setTotalCashBalance] = useState(0);
    const [totalAssetBalance, setTotalAssetBalance] = useState(0);
    const [payableBalance, setPayableBalance] = useState(0);
    const [actualBalance, setActualBalance] = useState(0);

    // Calculate USD balances
    const totalBalanceUSD = totalBalance / exchangeRate;
    const totalCashBalanceUSD = totalCashBalance / exchangeRate;
    const totalAssetBalanceUSD = totalAssetBalance / exchangeRate;
    const payableBalanceUSD = payableBalance / exchangeRate;
    const actualBalanceUSD = actualBalance / exchangeRate;

    const fetchAssets = async () => {
        try {
            const Api = process.env.REACT_APP_WEBZASH_URL;
            const apiKey = process.env.REACT_APP_API_KEY;

            // Step 1: Fetch all groups to find Bank Accounts and Cash-in-Hand
            const groupsResponse = await axios.get(`${Api}/api/groups/index`, {
                headers: { 'x-api-key': apiKey, 'Accept': 'application/json' },
            });

            console.log('Groups API Response:', groupsResponse.data);

            // The response structure might be different - let's check it
            const groupsData = groupsResponse.data.data || groupsResponse.data || [];
            console.log('Groups Data Structure:', groupsData);

            // Extract the Group objects from the array
            let allGroups = [];
            if (Array.isArray(groupsData) && groupsData.length > 0) {
                // Check if the structure is [{Group: {...}}, {Group: {...}}]
                if (groupsData[0] && groupsData[0].Group) {
                    allGroups = groupsData.map(item => item.Group);
                } else {
                    // If it's already flat structure
                    allGroups = groupsData;
                }
            }

            console.log('Processed Groups:', allGroups);

            // Find Bank Accounts and Cash-in-Hand group IDs
            const bankGroup = allGroups.find(group =>
                group.name === 'Bank Accounts'
            );
            const cashGroup = allGroups.find(group =>
                group.name === 'Cash-in-Hand'
            );

            console.log('Bank Group Found:', bankGroup);
            console.log('Cash Group Found:', cashGroup);

            let bankTotal = 0;
            let cashTotal = 0;
            let bankLedgersList = [];
            let cashLedgersList = [];

            // Step 2: Fetch bank ledgers using the new API endpoint
            if (bankGroup?.id) {
                try {
                    console.log('Fetching bank ledgers for group ID:', bankGroup.id);

                    // Try the new endpoint first
                    const bankLedgersResponse = await axios.get(
                        `${Api}/api/ledgers/getByGroupId/${bankGroup.id}`,
                        {
                            headers: { 'x-api-key': apiKey, 'Accept': 'application/json' },
                        }
                    );

                    console.log('Bank Ledgers API Response:', bankLedgersResponse.data);

                    if (bankLedgersResponse.data.status === 'success') {
                        const bankLedgersData = bankLedgersResponse.data.data || [];
                        console.log('Bank Ledgers Data:', bankLedgersData);

                        // Process each bank ledger to get its current balance from ledger statement
                        bankLedgersList = await processLedgersWithStatements(bankLedgersData, 'bank');
                        bankTotal = bankLedgersList.reduce((sum, bank) => sum + bank.signedAmount, 0);
                        setBankLedgers(bankLedgersList);
                        setTotalBalance(bankTotal);

                        console.log('Bank Ledgers loaded via API:', bankLedgersList.length);
                        console.log('Bank Total:', bankTotal);
                    } else {
                        // If API returns error, use fallback
                        console.log('Bank API returned error, using fallback');
                        await fetchLedgersByStatement(bankGroup.id, 'bank');
                    }
                } catch (error) {
                    console.error('Error using getByGroupId API for bank:', error);
                    console.log('Error details:', error.response?.data || error.message);
                    // Fallback to alternative method
                    await fetchLedgersByStatement(bankGroup.id, 'bank');
                }
            } else {
                console.log('No Bank Accounts group found');
            }

            // Step 3: Fetch cash ledgers using the new API endpoint
            if (cashGroup?.id) {
                try {
                    console.log('Fetching cash ledgers for group ID:', cashGroup.id);

                    // Try the new endpoint first
                    const cashLedgersResponse = await axios.get(
                        `${Api}/api/ledgers/getByGroupId/${cashGroup.id}`,
                        {
                            headers: { 'x-api-key': apiKey, 'Accept': 'application/json' },
                        }
                    );

                    console.log('Cash Ledgers API Response:', cashLedgersResponse.data);

                    if (cashLedgersResponse.data.status === 'success') {
                        const cashLedgersData = cashLedgersResponse.data.data || [];
                        console.log('Cash Ledgers Data:', cashLedgersData);

                        // Process each cash ledger to get its current balance from ledger statement
                        cashLedgersList = await processLedgersWithStatements(cashLedgersData, 'cash');
                        cashTotal = cashLedgersList.reduce((sum, cash) => sum + cash.signedAmount, 0);
                        setCashInHandLedgers(cashLedgersList);
                        setTotalCashBalance(cashTotal);

                        console.log('Cash Ledgers loaded via API:', cashLedgersList.length);
                        console.log('Cash Total:', cashTotal);
                    } else {
                        // If API returns error, use fallback
                        console.log('Cash API returned error, using fallback');
                        await fetchLedgersByStatement(cashGroup.id, 'cash');
                    }
                } catch (error) {
                    console.error('Error using getByGroupId API for cash:', error);
                    console.log('Error details:', error.response?.data || error.message);
                    // Fallback to alternative method
                    await fetchLedgersByStatement(cashGroup.id, 'cash');
                }
            } else {
                console.log('No Cash-in-Hand group found');
            }

            // Step 4: Calculate totals
            const assetTotal = bankTotal + cashTotal;
            setTotalAssetBalance(assetTotal);

            console.log('Total Asset Balance (Bank + Cash):', assetTotal);

            // OPTIMIZATION: User requested to ONLY fetch Bank and Cash, ignoring liabilities.
            // Skipping fetchPayableLiabilitiesViaLedgers();
            setPayableBalance(0);

            // Actual balance is just assets now
            const actualBal = assetTotal;
            setActualBalance(actualBal);

            console.log('Actual Available Balance (Assets Only):', actualBal);

        } catch (error) {
            console.error('Error in fetchAssets:', error);
            console.log('Error details:', error.response?.data || error.message);
            // Final fallback - try to fetch all ledgers and categorize them
            await fetchAllLedgersAndCategorize();
        }
    };

    // Helper function to process ledgers and fetch their statements
    const processLedgersWithStatements = async (ledgers, type) => {
        const Api = process.env.REACT_APP_WEBZASH_URL;
        const apiKey = process.env.REACT_APP_API_KEY;

        let ledgerList = [];
        let ledgersToFetch = [];

        // 1. Identification Phase
        // Identify which ledgers already have balances and which need fetching
        ledgers.forEach(ledger => {
            if (ledger.current_balance !== undefined && ledger.current_balance !== null) {
                // Already has balance, we can process immediately or wait to combine
            } else {
                ledgersToFetch.push(ledger.id);
            }
        });

        let bulkBalancesMap = {};

        // 2. Fetch Phase (Bulk)
        if (ledgersToFetch.length > 0) {
            try {
                // console.log(`Fetching bulk balances for ${ledgersToFetch.length} ledgers`);
                const bulkResponse = await axios.post(
                    `${Api}/api/ledgers/getBalances`,
                    { ledger_ids: ledgersToFetch },
                    {
                        headers: { 'x-api-key': apiKey, 'Accept': 'application/json' },
                    }
                );

                if (bulkResponse.data.status === 'success' && Array.isArray(bulkResponse.data.data)) {
                    bulkResponse.data.data.forEach(item => {
                        bulkBalancesMap[item.id] = item;
                    });
                    // console.log('Bulk balances fetched successfully', bulkBalancesMap);
                }
            } catch (error) {
                console.error('Error fetching bulk balances:', error);
                // We will fall back to opening balance in the processing phase
            }
        }

        // 3. Processing Phase
        // Combine initial data + bulk fetched data + fallbacks
        ledgerList = ledgers.map(ledger => {
            let amount = 0;
            let dc = 'D';

            // Strategy A: Use pre-existing current_balance
            if (ledger.current_balance !== undefined && ledger.current_balance !== null) {
                amount = parseFloat(ledger.current_balance || 0);
                dc = ledger.current_balance_dc || 'D';
            }
            // Strategy B: Use fetched bulk balance
            else if (bulkBalancesMap[ledger.id]) {
                const fetched = bulkBalancesMap[ledger.id];
                amount = parseFloat(fetched.balance || 0);
                dc = fetched.dc || 'D';
            }
            // Strategy C: Fallback to opening balance
            else {
                // console.log(`Using opening balance fallback for ${ledger.name}`);
                amount = parseFloat(ledger.op_balance || 0);
                dc = ledger.op_balance_dc || 'D';
            }

            const signedAmount = dc === 'D' ? amount : -amount;

            return {
                id: ledger.id,
                name: ledger.name,
                signedAmount: signedAmount,
                displayAmount: Math.abs(amount),
                isDebit: dc === 'D',
                isCredit: dc === 'C',
                rawAmount: amount,
                dc: dc,
                ledgerData: ledger
            };
        });

        return ledgerList;
    };

    // Fallback method to fetch ledgers using ledger statement API
    const fetchLedgersByStatement = async (groupId, type = 'bank') => {
        try {
            const Api = process.env.REACT_APP_WEBZASH_URL;
            const apiKey = process.env.REACT_APP_API_KEY;

            console.log(`Fetching ${type} ledgers via fallback method for group ID:`, groupId);

            // First get all ledgers
            const allLedgersResponse = await axios.get(`${Api}/api/ledgers/index`, {
                headers: { 'x-api-key': apiKey, 'Accept': 'application/json' },
            });

            console.log('All Ledgers Response:', allLedgersResponse.data);

            const ledgersData = allLedgersResponse.data.data || allLedgersResponse.data || [];
            let allLedgers = [];

            // Extract ledger objects from response
            if (Array.isArray(ledgersData) && ledgersData.length > 0) {
                if (ledgersData[0] && ledgersData[0].Ledger) {
                    allLedgers = ledgersData.map(item => item.Ledger);
                } else {
                    allLedgers = ledgersData;
                }
            }

            console.log('Processed All Ledgers:', allLedgers);

            // Filter ledgers by group_id
            const filteredLedgers = allLedgers.filter(ledger => ledger.group_id == groupId);

            console.log(`Found ${filteredLedgers.length} ${type} ledgers via filtering`);

            if (filteredLedgers.length > 0) {
                const ledgerList = await processLedgersWithStatements(filteredLedgers, type);

                // Update state based on type
                if (type === 'bank') {
                    const bankTotal = ledgerList.reduce((sum, ledger) => sum + ledger.signedAmount, 0);
                    setBankLedgers(ledgerList);
                    setTotalBalance(bankTotal);
                    console.log(`Bank fallback complete: ${ledgerList.length} ledgers, total: ${bankTotal}`);
                } else {
                    const cashTotal = ledgerList.reduce((sum, ledger) => sum + ledger.signedAmount, 0);
                    setCashInHandLedgers(ledgerList);
                    setTotalCashBalance(cashTotal);
                    console.log(`Cash fallback complete: ${ledgerList.length} ledgers, total: ${cashTotal}`);
                }
                return;
            } else {
                console.log(`No ledgers found for group ID ${groupId}, trying search...`);

                // Try to get group name and search by that
                try {
                    const groupsResponse = await axios.get(`${Api}/api/groups/index`, {
                        headers: { 'x-api-key': apiKey, 'Accept': 'application/json' },
                    });

                    const groupsData = groupsResponse.data.data || groupsResponse.data || [];
                    let groups = [];

                    if (Array.isArray(groupsData) && groupsData.length > 0) {
                        if (groupsData[0] && groupsData[0].Group) {
                            groups = groupsData.map(item => item.Group);
                        } else {
                            groups = groupsData;
                        }
                    }

                    const group = groups.find(g => g.id == groupId);

                    if (group) {
                        console.log(`Group found: ${group.name}, searching ledgers...`);

                        // Search ledgers that might belong to this group by name pattern
                        const searchTerms = type === 'bank' ? ['bank', 'account'] : ['cash', 'hand'];

                        // Filter all ledgers by name containing search terms
                        const searchedLedgers = allLedgers.filter(ledger => {
                            const ledgerName = ledger.name.toLowerCase();
                            return searchTerms.some(term => ledgerName.includes(term));
                        });

                        console.log(`Found ${searchedLedgers.length} ${type} ledgers via name search`);

                        if (searchedLedgers.length > 0) {
                            const ledgerList = await processLedgersWithStatements(searchedLedgers, type);

                            // Update state based on type
                            if (type === 'bank') {
                                const bankTotal = ledgerList.reduce((sum, ledger) => sum + ledger.signedAmount, 0);
                                setBankLedgers(ledgerList);
                                setTotalBalance(bankTotal);
                                console.log(`Bank search fallback complete: ${ledgerList.length} ledgers, total: ${bankTotal}`);
                            } else {
                                const cashTotal = ledgerList.reduce((sum, ledger) => sum + ledger.signedAmount, 0);
                                setCashInHandLedgers(ledgerList);
                                setTotalCashBalance(cashTotal);
                                console.log(`Cash search fallback complete: ${ledgerList.length} ledgers, total: ${cashTotal}`);
                            }
                            return;
                        }
                    }
                } catch (searchError) {
                    console.error('Error searching ledgers:', searchError);
                }
            }

            console.log(`No ${type} ledgers found via fallback methods`);

        } catch (error) {
            console.error(`Error in fetchLedgersByStatement for ${type}:`, error);
        }
    };

    // Function to fetch payable liabilities using ledger statements
    const fetchPayableLiabilitiesViaLedgers = async () => {
        try {
            const Api = process.env.REACT_APP_WEBZASH_URL;
            const apiKey = process.env.REACT_APP_API_KEY;

            console.log('Fetching payable liabilities via ledgers...');

            // First, get all groups to find payable groups
            const groupsResponse = await axios.get(`${Api}/api/groups/index`, {
                headers: { 'x-api-key': apiKey, 'Accept': 'application/json' },
            });

            const groupsData = groupsResponse.data.data || groupsResponse.data || [];
            let allGroups = [];

            if (Array.isArray(groupsData) && groupsData.length > 0) {
                if (groupsData[0] && groupsData[0].Group) {
                    allGroups = groupsData.map(item => item.Group);
                } else {
                    allGroups = groupsData;
                }
            }

            // Find payable liability groups
            const payableGroupNames = [
                'Sundry Creditors (Vendors)',
                'Loans (Liabilities)',
                'Current Liabilities',
                'Duties and Taxes',
                'Creditors'
            ];

            const payableGroups = allGroups.filter(group =>
                payableGroupNames.includes(group.name)
            );

            console.log('Found payable groups:', payableGroups);

            let totalPayable = 0;
            let allPayableLedgers = [];

            // 1. Collect all ledgers from all payable groups
            for (const group of payableGroups) {
                try {
                    // Try to get ledgers for this group
                    let groupLedgers = [];

                    try {
                        const ledgersResponse = await axios.get(
                            `${Api}/api/ledgers/getByGroupId/${group.id}`,
                            {
                                headers: { 'x-api-key': apiKey, 'Accept': 'application/json' },
                            }
                        );

                        if (ledgersResponse.data.status === 'success') {
                            groupLedgers = ledgersResponse.data.data || [];
                        }
                    } catch (error) {
                        console.log(`Failed to get ledgers via API for group ${group.name}, trying fallback...`);
                        // Fallback logic omitted for brevity as it's complex, assuming primary works or minor loss
                        // If critical, we'd need a separate bulk fetch for ledgers first.
                        // For now, let's assume we can get ledgers.
                        // To be safe, let's skip fallback complexity here and verify if user needs it.
                        // Actually, let's keep it simple: if getByGroupId fails, we might just skip this group to strictly follow optimization.
                    }

                    if (groupLedgers.length > 0) {
                        allPayableLedgers = [...allPayableLedgers, ...groupLedgers];
                    }

                } catch (error) {
                    console.error(`Error processing payable group ${group?.name}:`, error);
                }
            }

            // 2. Bulk fetch balances for all collected ledgers
            if (allPayableLedgers.length > 0) {
                const ledgerIds = allPayableLedgers.map(l => l.id);
                // console.log(`Fetching bulk balances for ${ledgerIds.length} payable ledgers`);

                try {
                    const bulkResponse = await axios.post(
                        `${Api}/api/ledgers/getBalances`,
                        { ledger_ids: ledgerIds },
                        {
                            headers: { 'x-api-key': apiKey, 'Accept': 'application/json' },
                        }
                    );

                    if (bulkResponse.data.status === 'success' && Array.isArray(bulkResponse.data.data)) {
                        const balanceMap = {};
                        bulkResponse.data.data.forEach(item => {
                            balanceMap[item.id] = item;
                        });

                        // 3. Calculate total
                        allPayableLedgers.forEach(ledger => {
                            let amount = 0;
                            let dc = 'C'; // Default Credit for liabilities

                            // Strategy A: Pre-existing
                            if (ledger.current_balance !== undefined) {
                                amount = parseFloat(ledger.current_balance || 0);
                                dc = ledger.current_balance_dc || 'C';
                            }
                            // Strategy B: Bulk fetched
                            else if (balanceMap[ledger.id]) {
                                amount = parseFloat(balanceMap[ledger.id].balance || 0);
                                dc = balanceMap[ledger.id].dc || 'C';
                            }
                            // Strategy C: Op balance
                            else {
                                amount = parseFloat(ledger.op_balance || 0);
                                dc = ledger.op_balance_dc || 'C';
                            }

                            // For Liabilities: Credit is positive
                            const signedAmount = dc === 'C' ? amount : -amount;
                            totalPayable += signedAmount;
                        });
                    }
                } catch (err) {
                    console.error('Error bulk fetching payable balances:', err);
                }
            }

            console.log(`Total Payable Calculated: ${totalPayable}`);
            setPayableBalance(totalPayable);

        } catch (error) {
            console.error('Error fetching payable liabilities via ledgers:', error);
            setPayableBalance(0);
        }
    };

    // Final fallback: Fetch all ledgers and categorize them
    const fetchAllLedgersAndCategorize = async () => {
        try {
            const Api = process.env.REACT_APP_WEBZASH_URL;
            const apiKey = process.env.REACT_APP_API_KEY;

            console.log('Using final fallback: Fetching all ledgers and categorizing...');

            // Get all ledgers
            const allLedgersResponse = await axios.get(`${Api}/api/ledgers`, {
                headers: { 'x-api-key': apiKey, 'Accept': 'application/json' },
            });

            const ledgersData = allLedgersResponse.data.data || allLedgersResponse.data || [];
            let allLedgers = [];

            if (Array.isArray(ledgersData) && ledgersData.length > 0) {
                if (ledgersData[0] && ledgersData[0].Ledger) {
                    allLedgers = ledgersData.map(item => item.Ledger);
                } else {
                    allLedgers = ledgersData;
                }
            }

            console.log('Total ledgers found:', allLedgers.length);

            // Categorize ledgers by type based on name patterns
            let bankLedgersToProcess = [];
            let cashLedgersToProcess = [];
            let payableLedgersToProcess = [];
            let allIdsToFetch = [];

            // 1. Categorize
            for (const ledger of allLedgers) {
                const ledgerName = ledger.name.toLowerCase();

                if (ledgerName.includes('bank') || ledgerName.includes('account') ||
                    (ledger.code && (ledger.code.includes('BANK') || ledger.code.includes('ACC')))) {
                    bankLedgersToProcess.push(ledger);
                    allIdsToFetch.push(ledger.id);
                } else if (ledgerName.includes('cash') || ledgerName.includes('hand') ||
                    (ledger.code && (ledger.code.includes('CASH') || ledger.code.includes('CH')))) {
                    cashLedgersToProcess.push(ledger);
                    allIdsToFetch.push(ledger.id);
                }
                // Removed Payable categorization as per user request
            }

            // 2. Bulk Fetch
            let balanceMap = {};
            if (allIdsToFetch.length > 0) {
                try {
                    const bulkResponse = await axios.post(
                        `${Api}/api/ledgers/getBalances`,
                        { ledger_ids: allIdsToFetch },
                        {
                            headers: { 'x-api-key': apiKey, 'Accept': 'application/json' },
                        }
                    );

                    if (bulkResponse.data.status === 'success' && Array.isArray(bulkResponse.data.data)) {
                        bulkResponse.data.data.forEach(item => {
                            balanceMap[item.id] = item;
                        });
                    }
                } catch (err) {
                    console.error('Error bulk fetching balances in fallback:', err);
                }
            }

            // 3. Process each category
            const processCategory = (ledgers, defaultDc = 'D') => {
                return ledgers.map(ledger => {
                    let amount = 0;
                    let dc = defaultDc;

                    if (balanceMap[ledger.id]) {
                        amount = parseFloat(balanceMap[ledger.id].balance || 0);
                        dc = balanceMap[ledger.id].dc || defaultDc;
                    } else {
                        amount = parseFloat(ledger.op_balance || 0);
                        dc = ledger.op_balance_dc || defaultDc;
                    }

                    const signedAmount = dc === defaultDc ? amount : -amount;

                    return {
                        id: ledger.id,
                        name: ledger.name,
                        signedAmount: signedAmount,
                        displayAmount: Math.abs(amount),
                        isDebit: dc === 'D',
                        isCredit: dc === 'C',
                        rawAmount: amount,
                        dc: dc,
                        ledgerData: ledger
                    };
                });
            };

            const bankLedgersList = processCategory(bankLedgersToProcess, 'D');
            const cashLedgersList = processCategory(cashLedgersToProcess, 'D');

            // Calculate totals
            const bankTotal = bankLedgersList.reduce((sum, item) => sum + item.signedAmount, 0);
            const cashTotal = cashLedgersList.reduce((sum, item) => sum + item.signedAmount, 0);

            // Update state
            setBankLedgers(bankLedgersList);
            setCashInHandLedgers(cashLedgersList);
            setTotalBalance(bankTotal);
            setTotalCashBalance(cashTotal);

            const assetTotal = bankTotal + cashTotal;
            setTotalAssetBalance(assetTotal);

            // Payables ignored
            setPayableBalance(0);

            const actualBal = assetTotal;
            setActualBalance(actualBal);

            console.log('Final fallback completed (optimized):');
            console.log(`  Bank: ${bankLedgersList.length}, Cash: ${cashLedgersList.length}`);

        } catch (error) {
            console.error('Error in final fallback (fetch all ledgers):', error);
            // Set empty state
            setBankLedgers([]);
            setCashInHandLedgers([]);
            setTotalBalance(0);
            setTotalCashBalance(0);
            setTotalAssetBalance(0);
            setPayableBalance(0);
            setActualBalance(0);
        }
    };
    const fetchExchangeRate = async () => {
        try {
            // You can replace this with your actual exchange rate API
            // const response = await axios.get('https://api.exchangerate-api.com/v4/latest/AED');
            // setExchangeRate(response.data.rates.USD);

            setExchangeRate(3.692);
        } catch (error) {
            console.error('Error fetching exchange rate:', error);
            setExchangeRate(3.692);
        }
    };

    useEffect(() => {
        fetchAssets();
        fetchExchangeRate();
    }, []);

    const fetchCountries = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/countries`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });

            let countryList = response.data.Data;

            countryList = countryList.sort((a, b) => (a.id === 231 ? -1 : b.id === 231 ? 1 : 0));

            setCountries(countryList);
        } catch (error) {
            console.error('Error fetching countries:', error);
        }
    };

    useEffect(() => {
        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }

        debounceTimeoutRef.current = setTimeout(() => {
            fetchBanks(1, searchQuery);
        }, searchQuery ? 1500 : 0);

        return () => {
            if (debounceTimeoutRef.current) {
                clearTimeout(debounceTimeoutRef.current);
            }
        };
    }, [searchQuery, typeFilter]);

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    const WithDeletePermission = withPermission(({ children }) => children, ['bankaccount-delete']);
    const WithEditPermission = withPermission(({ children }) => children, ['bankaccount-edit']);
    const WithCreatePermission = withPermission(({ children }) => children, ['bankaccount-create']);

    const addBank = async (newBank) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;

            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.post(`${backendUrl}/api/bank-accounts`, newBank, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });
            const createdBank = response.data?.account;
            if (createdBank) {
                setBanks((prevBanks) => [...prevBanks, createdBank]);
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Bank account added successfully!',
                    timer: 1500,
                    showConfirmButton: false
                });
            } else {
                console.error('Creation failed, no data returned.');
            }

            handleCloseModal();
        } catch (error) {
            if (error.response?.data?.errors) {
                return error.response.data.errors;
            } else {
                console.error('Error adding bank:', error);
            }
        }
    };

    const editBank = async (bankId, updatedData) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;

            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.put(`${backendUrl}/api/bank-accounts/${bankId}`, updatedData, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });
            const updatedBank = response.data?.account;

            if (updatedBank) {
                setBanks((prevBanks) =>
                    prevBanks.map((bank) =>
                        bank.id === updatedBank.id ? updatedBank : bank
                    )
                );
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Bank account updated successfully!',
                    timer: 1500,
                    showConfirmButton: false
                });
            } else {
                console.error('Update failed, no data returned.');
            }

            handleCloseModal();
        } catch (error) {
            if (error.response?.data?.errors) {
                return error.response.data.errors;
            } else {
                console.error('Error updating bank:', error);
            }
        }
    };

    const deleteBank = async (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const backendUrl = process.env.REACT_APP_BACKEND_URL;

                    const userInfo = JSON.parse(localStorage.getItem('user-info'));
                    const origin = localStorage.getItem('user-origin');
                    const token = userInfo?.token;

                    await axios.delete(`${backendUrl}/api/bank-accounts/${id}`, {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Tenant-Origin': origin,
                        },
                    });

                    setBanks(banks.filter(bank => bank.id !== id));
                    Swal.fire(
                        "Deleted!",
                        "The bank has been deleted.",
                        "success"
                    );
                } catch (error) {
                    console.error('Error deleting bank:', error);
                    Swal.fire(
                        "Error!",
                        "Failed to delete bank. Please try again.",
                        "error"
                    );
                }
            }
        });
    };

    const handleShowModal = (bankId = null) => {
        if (bankId) {
            const bankToEdit = banks.find(bank => bank.id === bankId);
            if (bankToEdit) {
                setSelectedBankData(bankToEdit);
            }
        } else {
            setSelectedBankData(null);
        }
        setSelectedBankId(bankId);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedBankId(null);
        setSelectedBankData(null);
        setErrors({});
    };

    const handlePageClick = (data) => {
        const selectedPage = data.selected + 1;
        fetchBanks(selectedPage);
    };

    const handleFilterChange = (filterType, value) => {
        if (filterType === 'type') setTypeFilter(value);
        setFilterDropdown(null);
    };

    const handleImport = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const formData = new FormData();
            formData.append('file', file);

            const response = await axios.post(
                `${backendUrl}/api/bank-accounts/import`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data',
                        'Tenant-Origin': origin,
                    },
                }
            );

            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: response.data.message || ` Imported successfully!`,
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                },
            });

            setTimeout(() => window.location.reload(), 1000);
            event.target.value = '';

        } catch (error) {
            console.error('Import error:', error);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: error.response?.data?.errors || error.response?.errors || `Failed to import instance information`,
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                },
            });
            event.target.value = "";
        } finally {
        }
    };

    const handleExport = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(
                `${backendUrl}/api/bank-accounts/export`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                    responseType: 'blob',
                }
            );

            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;

            const contentDisposition = response.headers['content-disposition'];
            let filename = `BankAccounts_${new Date().toISOString().split('T')[0]}.xlsx`;

            if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
                if (filenameMatch.length === 2) {
                    filename = filenameMatch[1];
                }
            }

            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: `Exported successfully!`,
                timer: 2000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                },
            });

        } catch (error) {
            console.error('Export error:', error);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: `Failed to export`,
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                },
            });
        } finally {
        }
    };

    const formatCurrency = (amount, currency = 'AED') => {
        return parseFloat(amount || 0).toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    };

    const renderLedgerItems = (ledgers, title) => {
        if (ledgers.length === 0) return null;

        return (
            <>
                <tr className="category-header">
                    <td colSpan="5">
                        <strong>{title}</strong>
                    </td>
                </tr>
                {ledgers.map((item, index) => {
                    const balanceAED = item.signedAmount; // This is now signed (+ or -)
                    const balanceUSD = balanceAED / exchangeRate;

                    return (
                        <tr key={`${title}-${index}`} className="asset-item">
                            <td>
                                <div className="form-check font-size-16">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id={`${title}-check-${index}`}
                                    />
                                </div>
                            </td>
                            <td>
                                <div className="serial-number">{index + 1}</div>
                            </td>
                            <td>
                                <div className="asset-info">
                                    <div className="asset-name">{item.name}</div>

                                </div>
                            </td>
                            <td className="text-end">
                                <div className="balance-container">
                                    <div className={`balance-figure ${balanceAED < 0 ? 'text-danger' : 'text-dark'}`}>
                                        {formatCurrency(Math.abs(balanceAED))} AED
                                        {balanceAED < 0 && ' Cr'}
                                    </div>

                                </div>
                            </td>
                            <td className="text-end">
                                <div className="balance-container">
                                    <div className={`balance-figure ${balanceUSD < 0 ? 'text-danger' : 'text-dark'}`}>
                                        {formatCurrency(Math.abs(balanceUSD))} USD
                                        {balanceUSD < 0 && ' Cr'}
                                    </div>
                                </div>
                            </td>
                        </tr>
                    );
                })}
            </>
        );
    };

    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0 font-size-18">Assets - Bank & Cash</h4>
                            </div>
                        </div>
                    </div>

                    <div className="row mb-3">
                        <div className="col-12">
                            <div className="alert alert-info">
                                <div className="d-flex justify-content-between align-items-center">
                                    <div>
                                        <strong>Exchange Rate:</strong> 1 AED = {exchangeRate.toFixed(4)} USD
                                    </div>
                                    <div>
                                        <button
                                            className="btn btn-sm btn-outline-primary"
                                            onClick={() => {
                                                Swal.fire({
                                                    title: 'Update Exchange Rate',
                                                    input: 'number',
                                                    inputValue: exchangeRate,
                                                    inputAttributes: {
                                                        step: "0.0001",
                                                        min: "0.0001"
                                                    },
                                                    showCancelButton: true,
                                                    confirmButtonText: 'Update',
                                                    cancelButtonText: 'Cancel',
                                                    showLoaderOnConfirm: true,
                                                    preConfirm: (rate) => {
                                                        if (!rate || rate <= 0) {
                                                            Swal.showValidationMessage('Please enter a valid exchange rate');
                                                        }
                                                        return parseFloat(rate);
                                                    }
                                                }).then((result) => {
                                                    if (result.isConfirmed) {
                                                        setExchangeRate(result.value);
                                                        Swal.fire({
                                                            toast: true,
                                                            position: 'top-end',
                                                            icon: 'success',
                                                            title: 'Exchange rate updated',
                                                            timer: 2000,
                                                            showConfirmButton: false
                                                        });
                                                    }
                                                });
                                            }}
                                        >
                                            Update Rate
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="d-flex justify-content-between mb-3">
                                        <div className="d-flex">
                                            <div className="search-box me-2 mb-2 d-inline-block">
                                                <div className="position-relative">
                                                    <input
                                                        type="text"
                                                        className="form-control font-size-12"
                                                        placeholder="Search assets..."
                                                        value={searchQuery}
                                                        onChange={handleSearchChange}
                                                    />
                                                    <i className="bx bx-search-alt search-icon" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <table className="table align-middle table-nowrap table-check table-list">
                                            <thead className="table-light">
                                                <tr>
                                                    <th style={{ width: '20px' }} className="align-middle">
                                                        <div className="form-check font-size-16">
                                                            <input className="form-check-input" type="checkbox" id="checkAll" />
                                                            <label className="form-check-label" htmlFor="checkAll"></label>
                                                        </div>
                                                    </th>
                                                    <th className="align-middle">#</th>
                                                    <th>Account Name</th>
                                                    <th className="text-end">Balance (AED)</th>
                                                    <th className="text-end">Balance (USD)</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {bankLedgers.length === 0 && cashInHandLedgers.length === 0 ? (
                                                    <tr>
                                                        <td colSpan="5" className="text-center py-5">
                                                            <div className="no-data">
                                                                <i className="mdi mdi-database-remove-outline display-4 text-light"></i>
                                                                <h6 className="mt-3 text-muted">No assets available</h6>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    <>
                                                        {renderLedgerItems(bankLedgers, 'Bank Accounts')}
                                                        {renderLedgerItems(cashInHandLedgers, 'Cash in Hand')}

                                                        {/* Bank Accounts Summary */}
                                                        {bankLedgers.length > 0 && (
                                                            <tr className="summary-row category-total">
                                                                <td colSpan={3}>
                                                                    <strong>Total Bank Accounts</strong>
                                                                </td>
                                                                <td className="text-end">
                                                                    <strong className={totalBalance >= 0 ? 'text-success' : 'text-danger'}>
                                                                        {formatCurrency(Math.abs(totalBalance))} AED
                                                                        {totalBalance < 0 && ' (CR)'}
                                                                    </strong>
                                                                </td>
                                                                <td className="text-end">
                                                                    <strong className={totalBalanceUSD >= 0 ? 'text-success' : 'text-danger'}>
                                                                        {formatCurrency(Math.abs(totalBalanceUSD))} USD
                                                                        {totalBalanceUSD < 0 && ' (CR)'}
                                                                    </strong>
                                                                </td>
                                                            </tr>
                                                        )}

                                                        {/* Cash in Hand Summary */}
                                                        {cashInHandLedgers.length > 0 && (
                                                            <tr className="summary-row category-total">
                                                                <td colSpan={3}>
                                                                    <strong>Total Cash in Hand</strong>
                                                                </td>
                                                                <td className="text-end">
                                                                    <strong className={totalCashBalance >= 0 ? 'text-success' : 'text-danger'}>
                                                                        {formatCurrency(Math.abs(totalCashBalance))} AED
                                                                        {totalCashBalance < 0 && ' (CR)'}
                                                                    </strong>
                                                                </td>
                                                                <td className="text-end">
                                                                    <strong className={totalCashBalanceUSD >= 0 ? 'text-success' : 'text-danger'}>
                                                                        {formatCurrency(Math.abs(totalCashBalanceUSD))} USD
                                                                        {totalCashBalanceUSD < 0 && ' (CR)'}
                                                                    </strong>
                                                                </td>
                                                            </tr>
                                                        )}

                                                        {/* Total Assets Summary */}
                                                        <tr className="summary-row total-assets">
                                                            <td colSpan={3}>
                                                                <strong>Total Assets (Bank + Cash)</strong>
                                                            </td>
                                                            <td className="text-end">
                                                                <strong className={totalAssetBalance >= 0 ? 'text-success' : 'text-danger'}>
                                                                    {formatCurrency(Math.abs(totalAssetBalance))} AED
                                                                    {totalAssetBalance < 0 && ' (CR)'}
                                                                </strong>
                                                            </td>
                                                            <td className="text-end">
                                                                <strong className={totalAssetBalanceUSD >= 0 ? 'text-success' : 'text-danger'}>
                                                                    {formatCurrency(Math.abs(totalAssetBalanceUSD))} USD
                                                                    {totalAssetBalanceUSD < 0 && ' (CR)'}
                                                                </strong>
                                                            </td>
                                                        </tr>

                                                        {/* Payable Expenses */}
                                                        {payableBalance > 0 && (
                                                            <tr className="summary-row payable">
                                                                <td colSpan={3}>
                                                                    <span className="text-danger">Payable Expenses</span>
                                                                </td>
                                                                <td className="text-end text-danger">
                                                                    {formatCurrency(payableBalance)} AED
                                                                </td>
                                                                <td className="text-end text-danger">
                                                                    {formatCurrency(payableBalanceUSD)} USD
                                                                </td>
                                                            </tr>
                                                        )}

                                                        {/* Net Available Balance */}
                                                        <tr className="summary-row available">
                                                            <td colSpan={3}>
                                                                <span className="text-success">Net Available Balance</span>
                                                            </td>
                                                            <td className="text-end text-success">
                                                                <strong>{formatCurrency(actualBalance)} AED</strong>
                                                            </td>
                                                            <td className="text-end text-success">
                                                                <strong>{formatCurrency(actualBalanceUSD)} USD</strong>
                                                            </td>
                                                        </tr>
                                                    </>
                                                )}
                                            </tbody>
                                        </table>

                                        <div className="d-flex justify-content-end pagination-sm">
                                            <ReactPaginate
                                                previousLabel={'<'}
                                                nextLabel={'>'}
                                                breakLabel={'...'}
                                                pageCount={pageCount}
                                                marginPagesDisplayed={2}
                                                pageRangeDisplayed={3}
                                                onPageChange={handlePageClick}
                                                containerClassName={'pagination pagination-rounded justify-content-end mb-2'}
                                                pageClassName={'page-item'}
                                                pageLinkClassName={'page-link'}
                                                previousClassName={'page-item previous'}
                                                previousLinkClassName={'page-link'}
                                                nextClassName={'page-item next'}
                                                nextLinkClassName={'page-link'}
                                                breakClassName={'page-item'}
                                                breakLinkClassName={'page-link'}
                                                activeClassName={'active'}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <BankModal
                        key={selectedBankId || 'new'}
                        showModal={showModal}
                        handleClose={handleCloseModal}
                        bankId={selectedBankId}
                        bankData={selectedBankData}
                        addBank={addBank}
                        editBank={editBank}
                        banks={banks}
                        errors={errors}
                        setErrors={setErrors}
                        countries={countries}
                        fetchCountries={fetchCountries}
                    />
                </div>
            </div>
        </div>
    );
};
export default BankDetailList;